(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kvision-jsLegacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kvision-jsLegacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-chart-jsLegacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-chart-jsLegacy'.");
    }if (typeof this['kvision-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-chart-jsLegacy'. Its dependency 'kvision-jsLegacy' was not found. Please, check whether 'kvision-jsLegacy' is loaded prior to 'kvision-kvision-chart-jsLegacy'.");
    }root['kvision-kvision-chart-jsLegacy'] = factory(typeof this['kvision-kvision-chart-jsLegacy'] === 'undefined' ? {} : this['kvision-kvision-chart-jsLegacy'], kotlin, this['kvision-jsLegacy']);
  }
}(this, function (_, Kotlin, $module$kvision_jsLegacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var Widget = $module$kvision_jsLegacy.io.kvision.core.Widget;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var get_set = $module$kvision_jsLegacy.io.kvision.utils.get_set_5cw0du$;
  var emptySet = Kotlin.kotlin.collections.emptySet_287e2$;
  var getCallableRef = Kotlin.getCallableRef;
  var ensureNotNull = Kotlin.ensureNotNull;
  var i18n = $module$kvision_jsLegacy.io.kvision.i18n;
  var equals = Kotlin.equals;
  var Canvas = $module$kvision_jsLegacy.io.kvision.html.Canvas;
  var Enum = Kotlin.kotlin.Enum;
  var throwISE = Kotlin.throwISE;
  var throwCCE = Kotlin.throwCCE;
  var Object_init = Object;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var copyToArray = Kotlin.kotlin.collections.copyToArray;
  var defineInlineFunction = Kotlin.defineInlineFunction;
  Chart_0.prototype = Object.create(Widget.prototype);
  Chart_0.prototype.constructor = Chart_0;
  ChartCanvas.prototype = Object.create(Canvas.prototype);
  ChartCanvas.prototype.constructor = ChartCanvas;
  ChartType.prototype = Object.create(Enum.prototype);
  ChartType.prototype.constructor = ChartType;
  Eeasing.prototype = Object.create(Enum.prototype);
  Eeasing.prototype.constructor = Eeasing;
  InterpolationMode.prototype = Object.create(Enum.prototype);
  InterpolationMode.prototype.constructor = InterpolationMode;
  var kVManagerChartInit;
  function KVManagerChart() {
    KVManagerChart_instance = this;
    require('chart.js/dist/Chart.bundle.min.js');
  }
  KVManagerChart.prototype.init_8be2vx$ = function () {
  };
  KVManagerChart.$metadata$ = {kind: Kind_OBJECT, simpleName: 'KVManagerChart', interfaces: []};
  var KVManagerChart_instance = null;
  function KVManagerChart_getInstance() {
    if (KVManagerChart_instance === null) {
      new KVManagerChart();
    }return KVManagerChart_instance;
  }
  function Chart_0(configuration, chartWidth, chartHeight, classes, init) {
    Chart$Companion_getInstance();
    if (chartWidth === void 0)
      chartWidth = null;
    if (chartHeight === void 0)
      chartHeight = null;
    if (classes === void 0) {
      classes = emptySet();
    }if (init === void 0)
      init = null;
    Widget.call(this, classes);
    this.chartCanvas_8be2vx$ = new ChartCanvas(chartWidth, chartHeight, configuration);
    init != null ? init(this) : null;
  }
  Object.defineProperty(Chart_0.prototype, 'configuration', {configurable: true, get: function () {
    return this.chartCanvas_8be2vx$.configuration;
  }, set: function (value) {
    this.chartCanvas_8be2vx$.configuration = value;
  }});
  Object.defineProperty(Chart_0.prototype, 'jsChart', {configurable: true, get: function () {
    return this.chartCanvas_8be2vx$.jsChart;
  }});
  Chart_0.prototype.render = function () {
    return this.render_pjwf99$('div', [this.chartCanvas_8be2vx$.renderVNode()]);
  };
  Chart_0.prototype.getNativeConfig = function () {
    return this.chartCanvas_8be2vx$.getNativeConfig();
  };
  Chart_0.prototype.reset = function () {
    this.chartCanvas_8be2vx$.reset();
  };
  Chart_0.prototype.render_zdv7na$$default = function (duration, lazy) {
    this.chartCanvas_8be2vx$.render_zdv7na$(duration, lazy);
  };
  Chart_0.prototype.render_zdv7na$ = function (duration, lazy, callback$default) {
    if (duration === void 0)
      duration = null;
    if (lazy === void 0)
      lazy = false;
    callback$default ? callback$default(duration, lazy) : this.render_zdv7na$$default(duration, lazy);
  };
  Chart_0.prototype.stop = function () {
    this.chartCanvas_8be2vx$.stop();
  };
  Chart_0.prototype.resizeChart = function () {
    this.chartCanvas_8be2vx$.resizeChart();
  };
  Chart_0.prototype.clearChart = function () {
    this.chartCanvas_8be2vx$.clearChart();
  };
  Chart_0.prototype.update = function () {
    this.chartCanvas_8be2vx$.update();
  };
  Chart_0.prototype.toBase64Image = function () {
    return this.chartCanvas_8be2vx$.toBase64Image();
  };
  function Chart$Companion() {
    Chart$Companion_instance = this;
  }
  Chart$Companion.prototype.registerPlugin_za3rmp$ = function (plugin) {
    Chart.plugins.register(plugin);
  };
  Chart$Companion.prototype.unregisterPlugin_za3rmp$ = function (plugin) {
    Chart.plugins.unregister(plugin);
  };
  Chart$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Chart$Companion_instance = null;
  function Chart$Companion_getInstance() {
    if (Chart$Companion_instance === null) {
      new Chart$Companion();
    }return Chart$Companion_instance;
  }
  Chart_0.$metadata$ = {kind: Kind_CLASS, simpleName: 'Chart', interfaces: [Widget]};
  function chart($receiver, configuration, chartWidth, chartHeight, classes, className, init) {
    if (chartWidth === void 0)
      chartWidth = null;
    if (chartHeight === void 0)
      chartHeight = null;
    if (classes === void 0)
      classes = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var chart = new Chart_0(configuration, chartWidth, chartHeight, classes != null ? classes : get_set(className), init);
    $receiver.add_87eobz$(chart);
    return chart;
  }
  function ChartCanvas(canvasWidth, canvasHeight, configuration, classes) {
    if (canvasWidth === void 0)
      canvasWidth = null;
    if (canvasHeight === void 0)
      canvasHeight = null;
    if (classes === void 0) {
      classes = emptySet();
    }Canvas.call(this, canvasWidth, canvasHeight, classes);
    this.configuration_s7uvm7$_0 = configuration;
    this.jsChart = null;
  }
  Object.defineProperty(ChartCanvas.prototype, 'configuration', {configurable: true, get: function () {
    return this.configuration_s7uvm7$_0;
  }, set: function (value) {
    var tmp$, tmp$_0, tmp$_1;
    this.configuration_s7uvm7$_0 = value;
    var newConfig = toJs_19(value, getCallableRef('translate', function ($receiver, p1) {
      return $receiver.translate_61zpoe$(p1);
    }.bind(null, this)));
    if (newConfig.data != null)
      (tmp$ = this.jsChart) != null ? (tmp$.data = ensureNotNull(newConfig.data)) : null;
    if (newConfig.options != null)
      (tmp$_0 = this.jsChart) != null ? (tmp$_0.options = ensureNotNull(newConfig.options)) : null;
    (tmp$_1 = this.jsChart) != null ? tmp$_1.update() : null;
  }});
  ChartCanvas.prototype.render = function () {
    var tmp$, tmp$_0, tmp$_1;
    if (this.lastLanguage != null && !equals(this.lastLanguage, i18n.I18n.language)) {
      var newConfig = toJs_19(this.configuration, getCallableRef('translate', function ($receiver, p1) {
        return $receiver.translate_61zpoe$(p1);
      }.bind(null, this)));
      if (newConfig.data != null)
        (tmp$ = this.jsChart) != null ? (tmp$.data = ensureNotNull(newConfig.data)) : null;
      if (newConfig.options != null)
        (tmp$_0 = this.jsChart) != null ? (tmp$_0.options = ensureNotNull(newConfig.options)) : null;
      (tmp$_1 = this.jsChart) != null ? tmp$_1.update() : null;
    }return this.render_61zpoe$('canvas');
  };
  ChartCanvas.prototype.afterInsert_cmtal8$ = function (node) {
    this.jsChart = new Chart(this.context2D, toJs_19(this.configuration, getCallableRef('translate', function ($receiver, p1) {
      return $receiver.translate_61zpoe$(p1);
    }.bind(null, this))));
  };
  ChartCanvas.prototype.afterDestroy = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? tmp$.destroy() : null;
    this.jsChart = null;
  };
  ChartCanvas.prototype.getNativeConfig = function () {
    var tmp$;
    return (tmp$ = this.jsChart) != null ? tmp$.config : null;
  };
  ChartCanvas.prototype.reset = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? tmp$.reset() : null;
  };
  ChartCanvas.prototype.render_zdv7na$ = function (duration, lazy) {
    if (duration === void 0)
      duration = null;
    if (lazy === void 0)
      lazy = false;
    var tmp$;
    (tmp$ = this.jsChart) != null ? tmp$.render(duration, lazy) : null;
  };
  ChartCanvas.prototype.stop = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? tmp$.stop() : null;
  };
  ChartCanvas.prototype.resizeChart = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? tmp$.resize() : null;
  };
  ChartCanvas.prototype.clearChart = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? tmp$.clear() : null;
  };
  ChartCanvas.prototype.update = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? tmp$.update() : null;
  };
  ChartCanvas.prototype.toBase64Image = function () {
    var tmp$;
    return (tmp$ = this.jsChart) != null ? tmp$.toBase64Image() : null;
  };
  ChartCanvas.$metadata$ = {kind: Kind_CLASS, simpleName: 'ChartCanvas', interfaces: [Canvas]};
  function ChartType(name, ordinal, type) {
    Enum.call(this);
    this.type_8be2vx$ = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ChartType_initFields() {
    ChartType_initFields = function () {
    };
    ChartType$LINE_instance = new ChartType('LINE', 0, 'line');
    ChartType$BAR_instance = new ChartType('BAR', 1, 'bar');
    ChartType$HORIZONTALBAR_instance = new ChartType('HORIZONTALBAR', 2, 'horizontalBar');
    ChartType$RADAR_instance = new ChartType('RADAR', 3, 'radar');
    ChartType$DOUGHNUT_instance = new ChartType('DOUGHNUT', 4, 'doughnut');
    ChartType$PIE_instance = new ChartType('PIE', 5, 'pie');
    ChartType$POLARAREA_instance = new ChartType('POLARAREA', 6, 'polarArea');
    ChartType$BUBBLE_instance = new ChartType('BUBBLE', 7, 'bubble');
    ChartType$SCATTER_instance = new ChartType('SCATTER', 8, 'scatter');
  }
  var ChartType$LINE_instance;
  function ChartType$LINE_getInstance() {
    ChartType_initFields();
    return ChartType$LINE_instance;
  }
  var ChartType$BAR_instance;
  function ChartType$BAR_getInstance() {
    ChartType_initFields();
    return ChartType$BAR_instance;
  }
  var ChartType$HORIZONTALBAR_instance;
  function ChartType$HORIZONTALBAR_getInstance() {
    ChartType_initFields();
    return ChartType$HORIZONTALBAR_instance;
  }
  var ChartType$RADAR_instance;
  function ChartType$RADAR_getInstance() {
    ChartType_initFields();
    return ChartType$RADAR_instance;
  }
  var ChartType$DOUGHNUT_instance;
  function ChartType$DOUGHNUT_getInstance() {
    ChartType_initFields();
    return ChartType$DOUGHNUT_instance;
  }
  var ChartType$PIE_instance;
  function ChartType$PIE_getInstance() {
    ChartType_initFields();
    return ChartType$PIE_instance;
  }
  var ChartType$POLARAREA_instance;
  function ChartType$POLARAREA_getInstance() {
    ChartType_initFields();
    return ChartType$POLARAREA_instance;
  }
  var ChartType$BUBBLE_instance;
  function ChartType$BUBBLE_getInstance() {
    ChartType_initFields();
    return ChartType$BUBBLE_instance;
  }
  var ChartType$SCATTER_instance;
  function ChartType$SCATTER_getInstance() {
    ChartType_initFields();
    return ChartType$SCATTER_instance;
  }
  ChartType.$metadata$ = {kind: Kind_CLASS, simpleName: 'ChartType', interfaces: [Enum]};
  function ChartType$values() {
    return [ChartType$LINE_getInstance(), ChartType$BAR_getInstance(), ChartType$HORIZONTALBAR_getInstance(), ChartType$RADAR_getInstance(), ChartType$DOUGHNUT_getInstance(), ChartType$PIE_getInstance(), ChartType$POLARAREA_getInstance(), ChartType$BUBBLE_getInstance(), ChartType$SCATTER_getInstance()];
  }
  ChartType.values = ChartType$values;
  function ChartType$valueOf(name) {
    switch (name) {
      case 'LINE':
        return ChartType$LINE_getInstance();
      case 'BAR':
        return ChartType$BAR_getInstance();
      case 'HORIZONTALBAR':
        return ChartType$HORIZONTALBAR_getInstance();
      case 'RADAR':
        return ChartType$RADAR_getInstance();
      case 'DOUGHNUT':
        return ChartType$DOUGHNUT_getInstance();
      case 'PIE':
        return ChartType$PIE_getInstance();
      case 'POLARAREA':
        return ChartType$POLARAREA_getInstance();
      case 'BUBBLE':
        return ChartType$BUBBLE_getInstance();
      case 'SCATTER':
        return ChartType$SCATTER_getInstance();
      default:throwISE('No enum constant io.kvision.chart.ChartType.' + name);
    }
  }
  ChartType.valueOf_61zpoe$ = ChartType$valueOf;
  var InteractionMode$POINT_instance;
  var InteractionMode$NEAREST_instance;
  var InteractionMode$INDEX_instance;
  var InteractionMode$DATASET_instance;
  var InteractionMode$X_instance;
  var InteractionMode$Y_instance;
  function Eeasing(name, ordinal, mode) {
    Enum.call(this);
    this.mode_8be2vx$ = mode;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Eeasing_initFields() {
    Eeasing_initFields = function () {
    };
    Eeasing$LINEAR_instance = new Eeasing('LINEAR', 0, 'linear');
    Eeasing$EASEINQUAD_instance = new Eeasing('EASEINQUAD', 1, 'easeInQuad');
    Eeasing$EASEOUTQUAD_instance = new Eeasing('EASEOUTQUAD', 2, 'easeOutQuad');
    Eeasing$EASEINOUTQUAD_instance = new Eeasing('EASEINOUTQUAD', 3, 'easeInOutQuad');
    Eeasing$EASEINCUBIC_instance = new Eeasing('EASEINCUBIC', 4, 'easeInCubic');
    Eeasing$EASEOUTCUBIC_instance = new Eeasing('EASEOUTCUBIC', 5, 'easeOutCubic');
    Eeasing$EASEINOUTCUBIC_instance = new Eeasing('EASEINOUTCUBIC', 6, 'easeInOutCubic');
    Eeasing$EASEINQUART_instance = new Eeasing('EASEINQUART', 7, 'easeInQuart');
    Eeasing$EASEOUTQUART_instance = new Eeasing('EASEOUTQUART', 8, 'easeOutQuart');
    Eeasing$EASEINOUTQUART_instance = new Eeasing('EASEINOUTQUART', 9, 'easeInOutQuart');
    Eeasing$EASEINQUINT_instance = new Eeasing('EASEINQUINT', 10, 'easeInQuint');
    Eeasing$EASEOUTQUINT_instance = new Eeasing('EASEOUTQUINT', 11, 'easeOutQuint');
    Eeasing$EASEINOUTQUINT_instance = new Eeasing('EASEINOUTQUINT', 12, 'easeInOutQuint');
    Eeasing$EASEINSINE_instance = new Eeasing('EASEINSINE', 13, 'easeInSine');
    Eeasing$EASEOUTSINE_instance = new Eeasing('EASEOUTSINE', 14, 'easeOutSine');
    Eeasing$EASEINOUTSINE_instance = new Eeasing('EASEINOUTSINE', 15, 'easeInOutSine');
    Eeasing$EASEINEXPO_instance = new Eeasing('EASEINEXPO', 16, 'easeInExpo');
    Eeasing$EASEOUTEXPO_instance = new Eeasing('EASEOUTEXPO', 17, 'easeOutExpo');
    Eeasing$EASEINOUTEXPO_instance = new Eeasing('EASEINOUTEXPO', 18, 'easeInOutExpo');
    Eeasing$EASEINCIRC_instance = new Eeasing('EASEINCIRC', 19, 'easeInCirc');
    Eeasing$EASEOUTCIRC_instance = new Eeasing('EASEOUTCIRC', 20, 'easeOutCirc');
    Eeasing$EASEINOUTCIRC_instance = new Eeasing('EASEINOUTCIRC', 21, 'easeInOutCirc');
    Eeasing$EASEINELASTIC_instance = new Eeasing('EASEINELASTIC', 22, 'easeInElastic');
    Eeasing$EASEOUTELASTIC_instance = new Eeasing('EASEOUTELASTIC', 23, 'easeOutElastic');
    Eeasing$EASEINOUTELASTIC_instance = new Eeasing('EASEINOUTELASTIC', 24, 'easeInOutElastic');
    Eeasing$EASEINBACK_instance = new Eeasing('EASEINBACK', 25, 'easeInBack');
    Eeasing$EASEOUTBACK_instance = new Eeasing('EASEOUTBACK', 26, 'easeOutBack');
    Eeasing$EASEINOUTBACK_instance = new Eeasing('EASEINOUTBACK', 27, 'easeInOutBack');
    Eeasing$EASEINBOUNCE_instance = new Eeasing('EASEINBOUNCE', 28, 'easeInBounce');
    Eeasing$EASEOUTBOUNCE_instance = new Eeasing('EASEOUTBOUNCE', 29, 'easeOutBounce');
    Eeasing$EASEINOUTBOUNCE_instance = new Eeasing('EASEINOUTBOUNCE', 30, 'easeInOutBounce');
  }
  var Eeasing$LINEAR_instance;
  function Eeasing$LINEAR_getInstance() {
    Eeasing_initFields();
    return Eeasing$LINEAR_instance;
  }
  var Eeasing$EASEINQUAD_instance;
  function Eeasing$EASEINQUAD_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINQUAD_instance;
  }
  var Eeasing$EASEOUTQUAD_instance;
  function Eeasing$EASEOUTQUAD_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEOUTQUAD_instance;
  }
  var Eeasing$EASEINOUTQUAD_instance;
  function Eeasing$EASEINOUTQUAD_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINOUTQUAD_instance;
  }
  var Eeasing$EASEINCUBIC_instance;
  function Eeasing$EASEINCUBIC_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINCUBIC_instance;
  }
  var Eeasing$EASEOUTCUBIC_instance;
  function Eeasing$EASEOUTCUBIC_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEOUTCUBIC_instance;
  }
  var Eeasing$EASEINOUTCUBIC_instance;
  function Eeasing$EASEINOUTCUBIC_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINOUTCUBIC_instance;
  }
  var Eeasing$EASEINQUART_instance;
  function Eeasing$EASEINQUART_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINQUART_instance;
  }
  var Eeasing$EASEOUTQUART_instance;
  function Eeasing$EASEOUTQUART_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEOUTQUART_instance;
  }
  var Eeasing$EASEINOUTQUART_instance;
  function Eeasing$EASEINOUTQUART_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINOUTQUART_instance;
  }
  var Eeasing$EASEINQUINT_instance;
  function Eeasing$EASEINQUINT_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINQUINT_instance;
  }
  var Eeasing$EASEOUTQUINT_instance;
  function Eeasing$EASEOUTQUINT_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEOUTQUINT_instance;
  }
  var Eeasing$EASEINOUTQUINT_instance;
  function Eeasing$EASEINOUTQUINT_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINOUTQUINT_instance;
  }
  var Eeasing$EASEINSINE_instance;
  function Eeasing$EASEINSINE_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINSINE_instance;
  }
  var Eeasing$EASEOUTSINE_instance;
  function Eeasing$EASEOUTSINE_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEOUTSINE_instance;
  }
  var Eeasing$EASEINOUTSINE_instance;
  function Eeasing$EASEINOUTSINE_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINOUTSINE_instance;
  }
  var Eeasing$EASEINEXPO_instance;
  function Eeasing$EASEINEXPO_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINEXPO_instance;
  }
  var Eeasing$EASEOUTEXPO_instance;
  function Eeasing$EASEOUTEXPO_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEOUTEXPO_instance;
  }
  var Eeasing$EASEINOUTEXPO_instance;
  function Eeasing$EASEINOUTEXPO_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINOUTEXPO_instance;
  }
  var Eeasing$EASEINCIRC_instance;
  function Eeasing$EASEINCIRC_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINCIRC_instance;
  }
  var Eeasing$EASEOUTCIRC_instance;
  function Eeasing$EASEOUTCIRC_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEOUTCIRC_instance;
  }
  var Eeasing$EASEINOUTCIRC_instance;
  function Eeasing$EASEINOUTCIRC_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINOUTCIRC_instance;
  }
  var Eeasing$EASEINELASTIC_instance;
  function Eeasing$EASEINELASTIC_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINELASTIC_instance;
  }
  var Eeasing$EASEOUTELASTIC_instance;
  function Eeasing$EASEOUTELASTIC_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEOUTELASTIC_instance;
  }
  var Eeasing$EASEINOUTELASTIC_instance;
  function Eeasing$EASEINOUTELASTIC_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINOUTELASTIC_instance;
  }
  var Eeasing$EASEINBACK_instance;
  function Eeasing$EASEINBACK_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINBACK_instance;
  }
  var Eeasing$EASEOUTBACK_instance;
  function Eeasing$EASEOUTBACK_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEOUTBACK_instance;
  }
  var Eeasing$EASEINOUTBACK_instance;
  function Eeasing$EASEINOUTBACK_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINOUTBACK_instance;
  }
  var Eeasing$EASEINBOUNCE_instance;
  function Eeasing$EASEINBOUNCE_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINBOUNCE_instance;
  }
  var Eeasing$EASEOUTBOUNCE_instance;
  function Eeasing$EASEOUTBOUNCE_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEOUTBOUNCE_instance;
  }
  var Eeasing$EASEINOUTBOUNCE_instance;
  function Eeasing$EASEINOUTBOUNCE_getInstance() {
    Eeasing_initFields();
    return Eeasing$EASEINOUTBOUNCE_instance;
  }
  Eeasing.$metadata$ = {kind: Kind_CLASS, simpleName: 'Eeasing', interfaces: [Enum]};
  function Eeasing$values() {
    return [Eeasing$LINEAR_getInstance(), Eeasing$EASEINQUAD_getInstance(), Eeasing$EASEOUTQUAD_getInstance(), Eeasing$EASEINOUTQUAD_getInstance(), Eeasing$EASEINCUBIC_getInstance(), Eeasing$EASEOUTCUBIC_getInstance(), Eeasing$EASEINOUTCUBIC_getInstance(), Eeasing$EASEINQUART_getInstance(), Eeasing$EASEOUTQUART_getInstance(), Eeasing$EASEINOUTQUART_getInstance(), Eeasing$EASEINQUINT_getInstance(), Eeasing$EASEOUTQUINT_getInstance(), Eeasing$EASEINOUTQUINT_getInstance(), Eeasing$EASEINSINE_getInstance(), Eeasing$EASEOUTSINE_getInstance(), Eeasing$EASEINOUTSINE_getInstance(), Eeasing$EASEINEXPO_getInstance(), Eeasing$EASEOUTEXPO_getInstance(), Eeasing$EASEINOUTEXPO_getInstance(), Eeasing$EASEINCIRC_getInstance(), Eeasing$EASEOUTCIRC_getInstance(), Eeasing$EASEINOUTCIRC_getInstance(), Eeasing$EASEINELASTIC_getInstance(), Eeasing$EASEOUTELASTIC_getInstance(), Eeasing$EASEINOUTELASTIC_getInstance(), Eeasing$EASEINBACK_getInstance(), Eeasing$EASEOUTBACK_getInstance(), Eeasing$EASEINOUTBACK_getInstance(), Eeasing$EASEINBOUNCE_getInstance(), Eeasing$EASEOUTBOUNCE_getInstance(), Eeasing$EASEINOUTBOUNCE_getInstance()];
  }
  Eeasing.values = Eeasing$values;
  function Eeasing$valueOf(name) {
    switch (name) {
      case 'LINEAR':
        return Eeasing$LINEAR_getInstance();
      case 'EASEINQUAD':
        return Eeasing$EASEINQUAD_getInstance();
      case 'EASEOUTQUAD':
        return Eeasing$EASEOUTQUAD_getInstance();
      case 'EASEINOUTQUAD':
        return Eeasing$EASEINOUTQUAD_getInstance();
      case 'EASEINCUBIC':
        return Eeasing$EASEINCUBIC_getInstance();
      case 'EASEOUTCUBIC':
        return Eeasing$EASEOUTCUBIC_getInstance();
      case 'EASEINOUTCUBIC':
        return Eeasing$EASEINOUTCUBIC_getInstance();
      case 'EASEINQUART':
        return Eeasing$EASEINQUART_getInstance();
      case 'EASEOUTQUART':
        return Eeasing$EASEOUTQUART_getInstance();
      case 'EASEINOUTQUART':
        return Eeasing$EASEINOUTQUART_getInstance();
      case 'EASEINQUINT':
        return Eeasing$EASEINQUINT_getInstance();
      case 'EASEOUTQUINT':
        return Eeasing$EASEOUTQUINT_getInstance();
      case 'EASEINOUTQUINT':
        return Eeasing$EASEINOUTQUINT_getInstance();
      case 'EASEINSINE':
        return Eeasing$EASEINSINE_getInstance();
      case 'EASEOUTSINE':
        return Eeasing$EASEOUTSINE_getInstance();
      case 'EASEINOUTSINE':
        return Eeasing$EASEINOUTSINE_getInstance();
      case 'EASEINEXPO':
        return Eeasing$EASEINEXPO_getInstance();
      case 'EASEOUTEXPO':
        return Eeasing$EASEOUTEXPO_getInstance();
      case 'EASEINOUTEXPO':
        return Eeasing$EASEINOUTEXPO_getInstance();
      case 'EASEINCIRC':
        return Eeasing$EASEINCIRC_getInstance();
      case 'EASEOUTCIRC':
        return Eeasing$EASEOUTCIRC_getInstance();
      case 'EASEINOUTCIRC':
        return Eeasing$EASEINOUTCIRC_getInstance();
      case 'EASEINELASTIC':
        return Eeasing$EASEINELASTIC_getInstance();
      case 'EASEOUTELASTIC':
        return Eeasing$EASEOUTELASTIC_getInstance();
      case 'EASEINOUTELASTIC':
        return Eeasing$EASEINOUTELASTIC_getInstance();
      case 'EASEINBACK':
        return Eeasing$EASEINBACK_getInstance();
      case 'EASEOUTBACK':
        return Eeasing$EASEOUTBACK_getInstance();
      case 'EASEINOUTBACK':
        return Eeasing$EASEINOUTBACK_getInstance();
      case 'EASEINBOUNCE':
        return Eeasing$EASEINBOUNCE_getInstance();
      case 'EASEOUTBOUNCE':
        return Eeasing$EASEOUTBOUNCE_getInstance();
      case 'EASEINOUTBOUNCE':
        return Eeasing$EASEINOUTBOUNCE_getInstance();
      default:throwISE('No enum constant io.kvision.chart.Eeasing.' + name);
    }
  }
  Eeasing.valueOf_61zpoe$ = Eeasing$valueOf;
  var Position$TOP_instance;
  var Position$LEFT_instance;
  var Position$RIGHT_instance;
  var Position$BOTTOM_instance;
  var TooltipPosition$AVERAGE_instance;
  var TooltipPosition$NEAREST_instance;
  var PointStyle$CIRCLE_instance;
  var PointStyle$CROSS_instance;
  var PointStyle$CROSSROT_instance;
  var PointStyle$DASH_instance;
  var PointStyle$LINE_instance;
  var PointStyle$RECT_instance;
  var PointStyle$RECTROUNDED_instance;
  var PointStyle$RECTROT_instance;
  var PointStyle$START_instance;
  var PointStyle$TRIANGLE_instance;
  function InterpolationMode(name, ordinal, mode) {
    Enum.call(this);
    this.mode_8be2vx$ = mode;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function InterpolationMode_initFields() {
    InterpolationMode_initFields = function () {
    };
    InterpolationMode$DEFAULT_instance = new InterpolationMode('DEFAULT', 0, 'default');
    InterpolationMode$MONOTONE_instance = new InterpolationMode('MONOTONE', 1, 'monotone');
  }
  var InterpolationMode$DEFAULT_instance;
  function InterpolationMode$DEFAULT_getInstance() {
    InterpolationMode_initFields();
    return InterpolationMode$DEFAULT_instance;
  }
  var InterpolationMode$MONOTONE_instance;
  function InterpolationMode$MONOTONE_getInstance() {
    InterpolationMode_initFields();
    return InterpolationMode$MONOTONE_instance;
  }
  InterpolationMode.$metadata$ = {kind: Kind_CLASS, simpleName: 'InterpolationMode', interfaces: [Enum]};
  function InterpolationMode$values() {
    return [InterpolationMode$DEFAULT_getInstance(), InterpolationMode$MONOTONE_getInstance()];
  }
  InterpolationMode.values = InterpolationMode$values;
  function InterpolationMode$valueOf(name) {
    switch (name) {
      case 'DEFAULT':
        return InterpolationMode$DEFAULT_getInstance();
      case 'MONOTONE':
        return InterpolationMode$MONOTONE_getInstance();
      default:throwISE('No enum constant io.kvision.chart.InterpolationMode.' + name);
    }
  }
  InterpolationMode.valueOf_61zpoe$ = InterpolationMode$valueOf;
  var ScalesType$CATEGORY_instance;
  var ScalesType$LINEAR_instance;
  var ScalesType$LOGARITHMIC_instance;
  var ScalesType$TIME_instance;
  var ScalesType$RADIALLINEAR_instance;
  var LineCap$BUTT_instance;
  var LineCap$ROUND_instance;
  var LineCap$SQUARE_instance;
  var LineJoin$BEVEL_instance;
  var LineJoin$ROUND_instance;
  var LineJoin$MITER_instance;
  var LegendAlign$CENTER_instance;
  var LegendAlign$END_instance;
  var LegendAlign$START_instance;
  var TooltipAlign$CENTER_instance;
  var TooltipAlign$LEFT_instance;
  var TooltipAlign$RIGHT_instance;
  function toJs($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.mode = $receiver.mode.mode_8be2vx$;
    $receiver_0.animationDuration = $receiver.animationDuration;
    $receiver_0.intersect = $receiver.intersect;
    $receiver_0.axis = $receiver.axis;
    return $receiver_0;
  }
  function AnimationOptions(duration, easing, onProgress, onComplete) {
    if (duration === void 0)
      duration = 1000;
    if (easing === void 0)
      easing = Eeasing$EASEOUTQUART_getInstance();
    if (onProgress === void 0)
      onProgress = null;
    if (onComplete === void 0)
      onComplete = null;
    this.duration = duration;
    this.easing = easing;
    this.onProgress = onProgress;
    this.onComplete = onComplete;
  }
  AnimationOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'AnimationOptions', interfaces: []};
  AnimationOptions.prototype.component1 = function () {
    return this.duration;
  };
  AnimationOptions.prototype.component2 = function () {
    return this.easing;
  };
  AnimationOptions.prototype.component3 = function () {
    return this.onProgress;
  };
  AnimationOptions.prototype.component4 = function () {
    return this.onComplete;
  };
  AnimationOptions.prototype.copy_xj9wj7$ = function (duration, easing, onProgress, onComplete) {
    return new AnimationOptions(duration === void 0 ? this.duration : duration, easing === void 0 ? this.easing : easing, onProgress === void 0 ? this.onProgress : onProgress, onComplete === void 0 ? this.onComplete : onComplete);
  };
  AnimationOptions.prototype.toString = function () {
    return 'AnimationOptions(duration=' + Kotlin.toString(this.duration) + (', easing=' + Kotlin.toString(this.easing)) + (', onProgress=' + Kotlin.toString(this.onProgress)) + (', onComplete=' + Kotlin.toString(this.onComplete)) + ')';
  };
  AnimationOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.duration) | 0;
    result = result * 31 + Kotlin.hashCode(this.easing) | 0;
    result = result * 31 + Kotlin.hashCode(this.onProgress) | 0;
    result = result * 31 + Kotlin.hashCode(this.onComplete) | 0;
    return result;
  };
  AnimationOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.duration, other.duration) && Kotlin.equals(this.easing, other.easing) && Kotlin.equals(this.onProgress, other.onProgress) && Kotlin.equals(this.onComplete, other.onComplete)))));
  };
  function toJs_0($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.duration = $receiver.duration;
    $receiver_0.easing = $receiver.easing.mode_8be2vx$;
    if ($receiver.onProgress != null)
      $receiver_0.onProgress = $receiver.onProgress;
    if ($receiver.onComplete != null)
      $receiver_0.onComplete = $receiver.onComplete;
    return $receiver_0;
  }
  function LayoutPaddingObject(top, right, bottom, left) {
    if (top === void 0)
      top = null;
    if (right === void 0)
      right = null;
    if (bottom === void 0)
      bottom = null;
    if (left === void 0)
      left = null;
    this.top = top;
    this.right = right;
    this.bottom = bottom;
    this.left = left;
  }
  LayoutPaddingObject.$metadata$ = {kind: Kind_CLASS, simpleName: 'LayoutPaddingObject', interfaces: []};
  LayoutPaddingObject.prototype.component1 = function () {
    return this.top;
  };
  LayoutPaddingObject.prototype.component2 = function () {
    return this.right;
  };
  LayoutPaddingObject.prototype.component3 = function () {
    return this.bottom;
  };
  LayoutPaddingObject.prototype.component4 = function () {
    return this.left;
  };
  LayoutPaddingObject.prototype.copy_po2tg0$ = function (top, right, bottom, left) {
    return new LayoutPaddingObject(top === void 0 ? this.top : top, right === void 0 ? this.right : right, bottom === void 0 ? this.bottom : bottom, left === void 0 ? this.left : left);
  };
  LayoutPaddingObject.prototype.toString = function () {
    return 'LayoutPaddingObject(top=' + Kotlin.toString(this.top) + (', right=' + Kotlin.toString(this.right)) + (', bottom=' + Kotlin.toString(this.bottom)) + (', left=' + Kotlin.toString(this.left)) + ')';
  };
  LayoutPaddingObject.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.top) | 0;
    result = result * 31 + Kotlin.hashCode(this.right) | 0;
    result = result * 31 + Kotlin.hashCode(this.bottom) | 0;
    result = result * 31 + Kotlin.hashCode(this.left) | 0;
    return result;
  };
  LayoutPaddingObject.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.top, other.top) && Kotlin.equals(this.right, other.right) && Kotlin.equals(this.bottom, other.bottom) && Kotlin.equals(this.left, other.left)))));
  };
  function toJs_1($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.top != null)
      $receiver_0.top = $receiver.top;
    if ($receiver.right != null)
      $receiver_0.right = $receiver.right;
    if ($receiver.bottom != null)
      $receiver_0.bottom = $receiver.bottom;
    if ($receiver.left != null)
      $receiver_0.left = $receiver.left;
    return $receiver_0;
  }
  function LayoutOptions(padding) {
    this.padding = padding;
  }
  LayoutOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'LayoutOptions', interfaces: []};
  LayoutOptions.prototype.component1 = function () {
    return this.padding;
  };
  LayoutOptions.prototype.copy_8yk0vh$ = function (padding) {
    return new LayoutOptions(padding === void 0 ? this.padding : padding);
  };
  LayoutOptions.prototype.toString = function () {
    return 'LayoutOptions(padding=' + Kotlin.toString(this.padding) + ')';
  };
  LayoutOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.padding) | 0;
    return result;
  };
  LayoutOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.padding, other.padding))));
  };
  function toJs_2($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.padding = toJs_1($receiver.padding);
    return $receiver_0;
  }
  function toJs_3($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.boxWidth = $receiver.boxWidth;
    $receiver_0.fontSize = $receiver.fontSize;
    if ($receiver.fontStyle != null)
      $receiver_0.fontStyle = $receiver.fontStyle.name;
    if ($receiver.fontColor != null)
      $receiver_0.fontColor = $receiver.fontColor.asString();
    if ($receiver.fontFamily != null)
      $receiver_0.fontFamily = $receiver.fontFamily;
    $receiver_0.padding = $receiver.padding;
    if ($receiver.generateLabels != null)
      $receiver_0.generateLabels = $receiver.generateLabels;
    if ($receiver.filter != null)
      $receiver_0.filter = $receiver.filter;
    $receiver_0.usePointStyle = $receiver.usePointStyle;
    return $receiver_0;
  }
  function toJs_4($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.display = $receiver.display;
    $receiver_0.position = $receiver.position.position_8be2vx$;
    $receiver_0.fullWidth = $receiver.fullWidth;
    $receiver_0.reverse = $receiver.reverse;
    if ($receiver.onClick != null)
      $receiver_0.onClick = $receiver.onClick;
    if ($receiver.onHover != null)
      $receiver_0.onHover = $receiver.onHover;
    if ($receiver.labels != null)
      $receiver_0.labels = toJs_3($receiver.labels);
    if ($receiver.align != null)
      $receiver_0.align = $receiver.align.mode_8be2vx$;
    if ($receiver.onLeave != null)
      $receiver_0.onLeave = $receiver.onLeave;
    return $receiver_0;
  }
  function toJs_5($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    $receiver_0.display = $receiver.display;
    $receiver_0.position = $receiver.position.position_8be2vx$;
    $receiver_0.fontSize = $receiver.fontSize;
    if ($receiver.fontStyle != null)
      $receiver_0.fontStyle = $receiver.fontStyle.name;
    if ($receiver.fontColor != null)
      $receiver_0.fontColor = $receiver.fontColor.asString();
    if ($receiver.fontFamily != null)
      $receiver_0.fontFamily = $receiver.fontFamily;
    $receiver_0.padding = $receiver.padding;
    if ($receiver.lineHeight != null)
      $receiver_0.lineHeight = $receiver.lineHeight;
    if ($receiver.text != null) {
      var $receiver_1 = $receiver.text;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver_1, 10));
      var tmp$;
      tmp$ = $receiver_1.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(i18nTranslator(item));
      }
      $receiver_0.text = copyToArray(destination);
    }if ($receiver.fullWidth != null)
      $receiver_0.fullWidth = $receiver.fullWidth;
    return $receiver_0;
  }
  function toJs_6($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.beforeTitle != null)
      $receiver_0.beforeTitle = $receiver.beforeTitle;
    if ($receiver.title != null)
      $receiver_0.title = $receiver.title;
    if ($receiver.afterTitle != null)
      $receiver_0.afterTitle = $receiver.afterTitle;
    if ($receiver.beforeBody != null)
      $receiver_0.beforeBody = $receiver.beforeBody;
    if ($receiver.beforeLabel != null)
      $receiver_0.beforeLabel = $receiver.beforeLabel;
    if ($receiver.label != null)
      $receiver_0.label = $receiver.label;
    if ($receiver.labelColor != null)
      $receiver_0.labelColor = $receiver.labelColor;
    if ($receiver.labelTextColor != null)
      $receiver_0.labelTextColor = $receiver.labelTextColor;
    if ($receiver.afterLabel != null)
      $receiver_0.afterLabel = $receiver.afterLabel;
    if ($receiver.afterBody != null)
      $receiver_0.afterBody = $receiver.afterBody;
    if ($receiver.beforeFooter != null)
      $receiver_0.beforeFooter = $receiver.beforeFooter;
    if ($receiver.footer != null)
      $receiver_0.footer = $receiver.footer;
    if ($receiver.afterFooter != null)
      $receiver_0.afterFooter = $receiver.afterFooter;
    return $receiver_0;
  }
  function toJs_7($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.enabled = $receiver.enabled;
    if ($receiver.custom != null)
      $receiver_0.custom = $receiver.custom;
    $receiver_0.mode = $receiver.mode.mode_8be2vx$;
    $receiver_0.intersect = $receiver.intersect;
    $receiver_0.position = $receiver.position.mode_8be2vx$;
    if ($receiver.callbacks != null)
      $receiver_0.callbacks = toJs_6($receiver.callbacks);
    if ($receiver.filter != null)
      $receiver_0.filter = $receiver.filter;
    if ($receiver.itemSort != null)
      $receiver_0.itemSort = $receiver.itemSort;
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    $receiver_0.titleFontSize = $receiver.titleFontSize;
    if ($receiver.titleFontStyle != null)
      $receiver_0.titleFontStyle = $receiver.titleFontStyle.name;
    if ($receiver.titleFontColor != null)
      $receiver_0.titleFontColor = $receiver.titleFontColor.asString();
    if ($receiver.titleFontFamily != null)
      $receiver_0.titleFontFamily = $receiver.titleFontFamily;
    $receiver_0.titleSpacing = $receiver.titleSpacing;
    $receiver_0.titleMarginBottom = $receiver.titleMarginBottom;
    $receiver_0.bodyFontSize = $receiver.bodyFontSize;
    if ($receiver.bodyFontStyle != null)
      $receiver_0.bodyFontStyle = $receiver.bodyFontStyle.name;
    if ($receiver.bodyFontColor != null)
      $receiver_0.bodyFontColor = $receiver.bodyFontColor.asString();
    if ($receiver.bodyFontFamily != null)
      $receiver_0.bodyFontFamily = $receiver.bodyFontFamily;
    $receiver_0.bodySpacing = $receiver.bodySpacing;
    $receiver_0.footerFontSize = $receiver.footerFontSize;
    if ($receiver.footerFontStyle != null)
      $receiver_0.footerFontStyle = $receiver.footerFontStyle.name;
    if ($receiver.footerFontColor != null)
      $receiver_0.footerFontColor = $receiver.footerFontColor.asString();
    if ($receiver.footerFontFamily != null)
      $receiver_0.footerFontFamily = $receiver.footerFontFamily;
    $receiver_0.footerSpacing = $receiver.footerSpacing;
    $receiver_0.footerMarginTop = $receiver.footerMarginTop;
    $receiver_0.xPadding = $receiver.xPadding;
    $receiver_0.yPadding = $receiver.yPadding;
    $receiver_0.caretPadding = $receiver.caretPadding;
    $receiver_0.caretSize = $receiver.caretSize;
    $receiver_0.cornerRadius = $receiver.cornerRadius;
    if ($receiver.multiKeyBackground != null)
      $receiver_0.multiKeyBackground = $receiver.multiKeyBackground.asString();
    $receiver_0.displayColors = $receiver.displayColors;
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    $receiver_0.borderWidth = $receiver.borderWidth;
    if ($receiver.titleAlign != null)
      $receiver_0.titleAlign = $receiver.titleAlign.mode_8be2vx$;
    if ($receiver.bodyAlign != null)
      $receiver_0.bodyAlign = $receiver.bodyAlign.mode_8be2vx$;
    if ($receiver.footerAlign != null)
      $receiver_0.footerAlign = $receiver.footerAlign.mode_8be2vx$;
    return $receiver_0;
  }
  function toJs_8($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.radius = $receiver.radius;
    $receiver_0.pointStyle = $receiver.pointStyle.style_8be2vx$;
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    $receiver_0.borderWidth = $receiver.borderWidth;
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    $receiver_0.hitRadius = $receiver.hitRadius;
    $receiver_0.hoverRadius = $receiver.hoverRadius;
    $receiver_0.hoverBorderWidth = $receiver.hoverBorderWidth;
    return $receiver_0;
  }
  function LineOptions(cubicInterpolationMode, tension, backgroundColor, borderWidth, borderColor, borderCapStyle, borderDash, borderDashOffset, borderJoinStyle, capBezierPoints, fill, stepped) {
    if (cubicInterpolationMode === void 0)
      cubicInterpolationMode = InterpolationMode$DEFAULT_getInstance();
    if (tension === void 0)
      tension = 0.2;
    if (backgroundColor === void 0)
      backgroundColor = null;
    if (borderWidth === void 0)
      borderWidth = 1;
    if (borderColor === void 0)
      borderColor = null;
    if (borderCapStyle === void 0)
      borderCapStyle = null;
    if (borderDash === void 0)
      borderDash = null;
    if (borderDashOffset === void 0)
      borderDashOffset = 0;
    if (borderJoinStyle === void 0)
      borderJoinStyle = null;
    if (capBezierPoints === void 0)
      capBezierPoints = true;
    if (fill === void 0)
      fill = true;
    if (stepped === void 0)
      stepped = false;
    this.cubicInterpolationMode = cubicInterpolationMode;
    this.tension = tension;
    this.backgroundColor = backgroundColor;
    this.borderWidth = borderWidth;
    this.borderColor = borderColor;
    this.borderCapStyle = borderCapStyle;
    this.borderDash = borderDash;
    this.borderDashOffset = borderDashOffset;
    this.borderJoinStyle = borderJoinStyle;
    this.capBezierPoints = capBezierPoints;
    this.fill = fill;
    this.stepped = stepped;
  }
  LineOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'LineOptions', interfaces: []};
  LineOptions.prototype.component1 = function () {
    return this.cubicInterpolationMode;
  };
  LineOptions.prototype.component2 = function () {
    return this.tension;
  };
  LineOptions.prototype.component3 = function () {
    return this.backgroundColor;
  };
  LineOptions.prototype.component4 = function () {
    return this.borderWidth;
  };
  LineOptions.prototype.component5 = function () {
    return this.borderColor;
  };
  LineOptions.prototype.component6 = function () {
    return this.borderCapStyle;
  };
  LineOptions.prototype.component7 = function () {
    return this.borderDash;
  };
  LineOptions.prototype.component8 = function () {
    return this.borderDashOffset;
  };
  LineOptions.prototype.component9 = function () {
    return this.borderJoinStyle;
  };
  LineOptions.prototype.component10 = function () {
    return this.capBezierPoints;
  };
  LineOptions.prototype.component11 = function () {
    return this.fill;
  };
  LineOptions.prototype.component12 = function () {
    return this.stepped;
  };
  LineOptions.prototype.copy_aert9k$ = function (cubicInterpolationMode, tension, backgroundColor, borderWidth, borderColor, borderCapStyle, borderDash, borderDashOffset, borderJoinStyle, capBezierPoints, fill, stepped) {
    return new LineOptions(cubicInterpolationMode === void 0 ? this.cubicInterpolationMode : cubicInterpolationMode, tension === void 0 ? this.tension : tension, backgroundColor === void 0 ? this.backgroundColor : backgroundColor, borderWidth === void 0 ? this.borderWidth : borderWidth, borderColor === void 0 ? this.borderColor : borderColor, borderCapStyle === void 0 ? this.borderCapStyle : borderCapStyle, borderDash === void 0 ? this.borderDash : borderDash, borderDashOffset === void 0 ? this.borderDashOffset : borderDashOffset, borderJoinStyle === void 0 ? this.borderJoinStyle : borderJoinStyle, capBezierPoints === void 0 ? this.capBezierPoints : capBezierPoints, fill === void 0 ? this.fill : fill, stepped === void 0 ? this.stepped : stepped);
  };
  LineOptions.prototype.toString = function () {
    return 'LineOptions(cubicInterpolationMode=' + Kotlin.toString(this.cubicInterpolationMode) + (', tension=' + Kotlin.toString(this.tension)) + (', backgroundColor=' + Kotlin.toString(this.backgroundColor)) + (', borderWidth=' + Kotlin.toString(this.borderWidth)) + (', borderColor=' + Kotlin.toString(this.borderColor)) + (', borderCapStyle=' + Kotlin.toString(this.borderCapStyle)) + (', borderDash=' + Kotlin.toString(this.borderDash)) + (', borderDashOffset=' + Kotlin.toString(this.borderDashOffset)) + (', borderJoinStyle=' + Kotlin.toString(this.borderJoinStyle)) + (', capBezierPoints=' + Kotlin.toString(this.capBezierPoints)) + (', fill=' + Kotlin.toString(this.fill)) + (', stepped=' + Kotlin.toString(this.stepped)) + ')';
  };
  LineOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.cubicInterpolationMode) | 0;
    result = result * 31 + Kotlin.hashCode(this.tension) | 0;
    result = result * 31 + Kotlin.hashCode(this.backgroundColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderCapStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderDash) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderDashOffset) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderJoinStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.capBezierPoints) | 0;
    result = result * 31 + Kotlin.hashCode(this.fill) | 0;
    result = result * 31 + Kotlin.hashCode(this.stepped) | 0;
    return result;
  };
  LineOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.cubicInterpolationMode, other.cubicInterpolationMode) && Kotlin.equals(this.tension, other.tension) && Kotlin.equals(this.backgroundColor, other.backgroundColor) && Kotlin.equals(this.borderWidth, other.borderWidth) && Kotlin.equals(this.borderColor, other.borderColor) && Kotlin.equals(this.borderCapStyle, other.borderCapStyle) && Kotlin.equals(this.borderDash, other.borderDash) && Kotlin.equals(this.borderDashOffset, other.borderDashOffset) && Kotlin.equals(this.borderJoinStyle, other.borderJoinStyle) && Kotlin.equals(this.capBezierPoints, other.capBezierPoints) && Kotlin.equals(this.fill, other.fill) && Kotlin.equals(this.stepped, other.stepped)))));
  };
  function toJs_9($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.cubicInterpolationMode = $receiver.cubicInterpolationMode.mode_8be2vx$;
    $receiver_0.tension = $receiver.tension;
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    $receiver_0.borderWidth = $receiver.borderWidth;
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    if ($receiver.borderCapStyle != null)
      $receiver_0.borderCapStyle = $receiver.borderCapStyle.mode_8be2vx$;
    if ($receiver.borderDash != null) {
      $receiver_0.borderDash = copyToArray($receiver.borderDash);
    }$receiver_0.borderDashOffset = $receiver.borderDashOffset;
    if ($receiver.borderJoinStyle != null)
      $receiver_0.borderJoinStyle = $receiver.borderJoinStyle.mode_8be2vx$;
    $receiver_0.capBezierPoints = $receiver.capBezierPoints;
    $receiver_0.fill = $receiver.fill;
    $receiver_0.stepped = $receiver.stepped;
    return $receiver_0;
  }
  function toJs_10($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    $receiver_0.borderWidth = $receiver.borderWidth;
    return $receiver_0;
  }
  function toJs_11($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    $receiver_0.borderWidth = $receiver.borderWidth;
    $receiver_0.borderSkipped = $receiver.borderSkipped.position_8be2vx$;
    return $receiver_0;
  }
  function ElementsOptions(point, line, arc, rectangle) {
    if (point === void 0)
      point = null;
    if (line === void 0)
      line = null;
    if (arc === void 0)
      arc = null;
    if (rectangle === void 0)
      rectangle = null;
    this.point = point;
    this.line = line;
    this.arc = arc;
    this.rectangle = rectangle;
  }
  ElementsOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'ElementsOptions', interfaces: []};
  ElementsOptions.prototype.component1 = function () {
    return this.point;
  };
  ElementsOptions.prototype.component2 = function () {
    return this.line;
  };
  ElementsOptions.prototype.component3 = function () {
    return this.arc;
  };
  ElementsOptions.prototype.component4 = function () {
    return this.rectangle;
  };
  ElementsOptions.prototype.copy_1rutuf$ = function (point, line, arc, rectangle) {
    return new ElementsOptions(point === void 0 ? this.point : point, line === void 0 ? this.line : line, arc === void 0 ? this.arc : arc, rectangle === void 0 ? this.rectangle : rectangle);
  };
  ElementsOptions.prototype.toString = function () {
    return 'ElementsOptions(point=' + Kotlin.toString(this.point) + (', line=' + Kotlin.toString(this.line)) + (', arc=' + Kotlin.toString(this.arc)) + (', rectangle=' + Kotlin.toString(this.rectangle)) + ')';
  };
  ElementsOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.point) | 0;
    result = result * 31 + Kotlin.hashCode(this.line) | 0;
    result = result * 31 + Kotlin.hashCode(this.arc) | 0;
    result = result * 31 + Kotlin.hashCode(this.rectangle) | 0;
    return result;
  };
  ElementsOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.point, other.point) && Kotlin.equals(this.line, other.line) && Kotlin.equals(this.arc, other.arc) && Kotlin.equals(this.rectangle, other.rectangle)))));
  };
  function toJs_12($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.point != null)
      $receiver_0.point = toJs_8($receiver.point);
    if ($receiver.line != null)
      $receiver_0.line = toJs_9($receiver.line);
    if ($receiver.arc != null)
      $receiver_0.arc = toJs_10($receiver.arc);
    if ($receiver.rectangle != null)
      $receiver_0.rectangle = toJs_11($receiver.rectangle);
    return $receiver_0;
  }
  function toJs_13($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.display = $receiver.display;
    if ($receiver.color != null)
      $receiver_0.color = $receiver.color.asString();
    if ($receiver.borderDash != null) {
      $receiver_0.borderDash = copyToArray($receiver.borderDash);
    }$receiver_0.borderDashOffset = $receiver.borderDashOffset;
    $receiver_0.lineWidth = $receiver.lineWidth;
    $receiver_0.drawBorder = $receiver.drawBorder;
    $receiver_0.drawOnChartArea = $receiver.drawOnChartArea;
    $receiver_0.drawTicks = $receiver.drawTicks;
    $receiver_0.tickMarkLength = $receiver.tickMarkLength;
    $receiver_0.zeroLineWidth = $receiver.zeroLineWidth;
    if ($receiver.zeroLineColor != null)
      $receiver_0.zeroLineColor = $receiver.zeroLineColor.asString();
    if ($receiver.zeroLineBorderDash != null) {
      $receiver_0.zeroLineBorderDash = copyToArray($receiver.zeroLineBorderDash);
    }$receiver_0.zeroLineBorderDashOffset = $receiver.zeroLineBorderDashOffset;
    $receiver_0.offsetGridLines = $receiver.offsetGridLines;
    if ($receiver.circular != null)
      $receiver_0.circular = $receiver.circular;
    if ($receiver.z != null)
      $receiver_0.z = $receiver.z;
    return $receiver_0;
  }
  function toJs_14($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    $receiver_0.display = $receiver.display;
    if ($receiver.labelString != null)
      $receiver_0.labelString = i18nTranslator($receiver.labelString);
    $receiver_0.fontSize = $receiver.fontSize;
    if ($receiver.fontStyle != null)
      $receiver_0.fontStyle = $receiver.fontStyle.name;
    if ($receiver.fontColor != null)
      $receiver_0.fontColor = $receiver.fontColor.asString();
    if ($receiver.fontFamily != null)
      $receiver_0.fontFamily = $receiver.fontFamily;
    if ($receiver.lineHeight != null)
      $receiver_0.lineHeight = $receiver.lineHeight;
    if ($receiver.padding != null)
      $receiver_0.padding = $receiver.padding;
    return $receiver_0;
  }
  function toJs_15($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.callback != null)
      $receiver_0.callback = $receiver.callback;
    $receiver_0.display = $receiver.display;
    $receiver_0.fontSize = $receiver.fontSize;
    if ($receiver.fontStyle != null)
      $receiver_0.fontStyle = $receiver.fontStyle.name;
    if ($receiver.fontColor != null)
      $receiver_0.fontColor = $receiver.fontColor.asString();
    if ($receiver.fontFamily != null)
      $receiver_0.fontFamily = $receiver.fontFamily;
    $receiver_0.reverse = $receiver.reverse;
    if ($receiver.minor != null)
      $receiver_0.minor = $receiver.minor;
    if ($receiver.major != null)
      $receiver_0.major = $receiver.major;
    if ($receiver.lineHeight != null)
      $receiver_0.lineHeight = $receiver.lineHeight;
    if ($receiver.padding != null)
      $receiver_0.padding = $receiver.padding;
    if ($receiver.z != null)
      $receiver_0.z = $receiver.z;
    return $receiver_0;
  }
  function ChartScales(type, display, position, gridLines, scaleLabel, ticks, xAxes, yAxes) {
    if (type === void 0)
      type = null;
    if (display === void 0)
      display = true;
    if (position === void 0)
      position = null;
    if (gridLines === void 0)
      gridLines = null;
    if (scaleLabel === void 0)
      scaleLabel = null;
    if (ticks === void 0)
      ticks = null;
    if (xAxes === void 0)
      xAxes = null;
    if (yAxes === void 0)
      yAxes = null;
    this.type = type;
    this.display = display;
    this.position = position;
    this.gridLines = gridLines;
    this.scaleLabel = scaleLabel;
    this.ticks = ticks;
    this.xAxes = xAxes;
    this.yAxes = yAxes;
  }
  ChartScales.$metadata$ = {kind: Kind_CLASS, simpleName: 'ChartScales', interfaces: []};
  ChartScales.prototype.component1 = function () {
    return this.type;
  };
  ChartScales.prototype.component2 = function () {
    return this.display;
  };
  ChartScales.prototype.component3 = function () {
    return this.position;
  };
  ChartScales.prototype.component4 = function () {
    return this.gridLines;
  };
  ChartScales.prototype.component5 = function () {
    return this.scaleLabel;
  };
  ChartScales.prototype.component6 = function () {
    return this.ticks;
  };
  ChartScales.prototype.component7 = function () {
    return this.xAxes;
  };
  ChartScales.prototype.component8 = function () {
    return this.yAxes;
  };
  ChartScales.prototype.copy_zb3bp8$ = function (type, display, position, gridLines, scaleLabel, ticks, xAxes, yAxes) {
    return new ChartScales(type === void 0 ? this.type : type, display === void 0 ? this.display : display, position === void 0 ? this.position : position, gridLines === void 0 ? this.gridLines : gridLines, scaleLabel === void 0 ? this.scaleLabel : scaleLabel, ticks === void 0 ? this.ticks : ticks, xAxes === void 0 ? this.xAxes : xAxes, yAxes === void 0 ? this.yAxes : yAxes);
  };
  ChartScales.prototype.toString = function () {
    return 'ChartScales(type=' + Kotlin.toString(this.type) + (', display=' + Kotlin.toString(this.display)) + (', position=' + Kotlin.toString(this.position)) + (', gridLines=' + Kotlin.toString(this.gridLines)) + (', scaleLabel=' + Kotlin.toString(this.scaleLabel)) + (', ticks=' + Kotlin.toString(this.ticks)) + (', xAxes=' + Kotlin.toString(this.xAxes)) + (', yAxes=' + Kotlin.toString(this.yAxes)) + ')';
  };
  ChartScales.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.type) | 0;
    result = result * 31 + Kotlin.hashCode(this.display) | 0;
    result = result * 31 + Kotlin.hashCode(this.position) | 0;
    result = result * 31 + Kotlin.hashCode(this.gridLines) | 0;
    result = result * 31 + Kotlin.hashCode(this.scaleLabel) | 0;
    result = result * 31 + Kotlin.hashCode(this.ticks) | 0;
    result = result * 31 + Kotlin.hashCode(this.xAxes) | 0;
    result = result * 31 + Kotlin.hashCode(this.yAxes) | 0;
    return result;
  };
  ChartScales.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.type, other.type) && Kotlin.equals(this.display, other.display) && Kotlin.equals(this.position, other.position) && Kotlin.equals(this.gridLines, other.gridLines) && Kotlin.equals(this.scaleLabel, other.scaleLabel) && Kotlin.equals(this.ticks, other.ticks) && Kotlin.equals(this.xAxes, other.xAxes) && Kotlin.equals(this.yAxes, other.yAxes)))));
  };
  function toJs_16($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    if ($receiver.type != null)
      $receiver_0.type = $receiver.type.type_8be2vx$;
    $receiver_0.display = $receiver.display;
    if ($receiver.position != null)
      $receiver_0.position = $receiver.position.position_8be2vx$;
    if ($receiver.gridLines != null)
      $receiver_0.gridLines = toJs_13($receiver.gridLines);
    if ($receiver.scaleLabel != null)
      $receiver_0.scaleLabel = toJs_14($receiver.scaleLabel, i18nTranslator);
    if ($receiver.ticks != null)
      $receiver_0.ticks = toJs_15($receiver.ticks);
    if ($receiver.xAxes != null) {
      $receiver_0.xAxes = copyToArray($receiver.xAxes);
    }if ($receiver.yAxes != null) {
      $receiver_0.yAxes = copyToArray($receiver.yAxes);
    }return $receiver_0;
  }
  function ChartOptions(responsive, responsiveAnimationDuration, aspectRatio, maintainAspectRatio, onResize, devicePixelRatio, hover, events, onHover, onClick, animation, layout, legend, legendCallback, title, tooltips, elements, scales, showLines, spanGaps, cutoutPercentage, circumference, rotation, plugins, scale) {
    if (responsive === void 0)
      responsive = true;
    if (responsiveAnimationDuration === void 0)
      responsiveAnimationDuration = 0;
    if (aspectRatio === void 0)
      aspectRatio = 2;
    if (maintainAspectRatio === void 0)
      maintainAspectRatio = true;
    if (onResize === void 0)
      onResize = null;
    if (devicePixelRatio === void 0)
      devicePixelRatio = null;
    if (hover === void 0)
      hover = null;
    if (events === void 0)
      events = null;
    if (onHover === void 0)
      onHover = null;
    if (onClick === void 0)
      onClick = null;
    if (animation === void 0)
      animation = null;
    if (layout === void 0)
      layout = null;
    if (legend === void 0)
      legend = null;
    if (legendCallback === void 0)
      legendCallback = null;
    if (title === void 0)
      title = null;
    if (tooltips === void 0)
      tooltips = null;
    if (elements === void 0)
      elements = null;
    if (scales === void 0)
      scales = null;
    if (showLines === void 0)
      showLines = null;
    if (spanGaps === void 0)
      spanGaps = null;
    if (cutoutPercentage === void 0)
      cutoutPercentage = null;
    if (circumference === void 0)
      circumference = null;
    if (rotation === void 0)
      rotation = null;
    if (plugins === void 0)
      plugins = null;
    if (scale === void 0)
      scale = null;
    this.responsive = responsive;
    this.responsiveAnimationDuration = responsiveAnimationDuration;
    this.aspectRatio = aspectRatio;
    this.maintainAspectRatio = maintainAspectRatio;
    this.onResize = onResize;
    this.devicePixelRatio = devicePixelRatio;
    this.hover = hover;
    this.events = events;
    this.onHover = onHover;
    this.onClick = onClick;
    this.animation = animation;
    this.layout = layout;
    this.legend = legend;
    this.legendCallback = legendCallback;
    this.title = title;
    this.tooltips = tooltips;
    this.elements = elements;
    this.scales = scales;
    this.showLines = showLines;
    this.spanGaps = spanGaps;
    this.cutoutPercentage = cutoutPercentage;
    this.circumference = circumference;
    this.rotation = rotation;
    this.plugins = plugins;
    this.scale = scale;
  }
  ChartOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'ChartOptions', interfaces: []};
  ChartOptions.prototype.component1 = function () {
    return this.responsive;
  };
  ChartOptions.prototype.component2 = function () {
    return this.responsiveAnimationDuration;
  };
  ChartOptions.prototype.component3 = function () {
    return this.aspectRatio;
  };
  ChartOptions.prototype.component4 = function () {
    return this.maintainAspectRatio;
  };
  ChartOptions.prototype.component5 = function () {
    return this.onResize;
  };
  ChartOptions.prototype.component6 = function () {
    return this.devicePixelRatio;
  };
  ChartOptions.prototype.component7 = function () {
    return this.hover;
  };
  ChartOptions.prototype.component8 = function () {
    return this.events;
  };
  ChartOptions.prototype.component9 = function () {
    return this.onHover;
  };
  ChartOptions.prototype.component10 = function () {
    return this.onClick;
  };
  ChartOptions.prototype.component11 = function () {
    return this.animation;
  };
  ChartOptions.prototype.component12 = function () {
    return this.layout;
  };
  ChartOptions.prototype.component13 = function () {
    return this.legend;
  };
  ChartOptions.prototype.component14 = function () {
    return this.legendCallback;
  };
  ChartOptions.prototype.component15 = function () {
    return this.title;
  };
  ChartOptions.prototype.component16 = function () {
    return this.tooltips;
  };
  ChartOptions.prototype.component17 = function () {
    return this.elements;
  };
  ChartOptions.prototype.component18 = function () {
    return this.scales;
  };
  ChartOptions.prototype.component19 = function () {
    return this.showLines;
  };
  ChartOptions.prototype.component20 = function () {
    return this.spanGaps;
  };
  ChartOptions.prototype.component21 = function () {
    return this.cutoutPercentage;
  };
  ChartOptions.prototype.component22 = function () {
    return this.circumference;
  };
  ChartOptions.prototype.component23 = function () {
    return this.rotation;
  };
  ChartOptions.prototype.component24 = function () {
    return this.plugins;
  };
  ChartOptions.prototype.component25 = function () {
    return this.scale;
  };
  ChartOptions.prototype.copy_tbrhbq$ = function (responsive, responsiveAnimationDuration, aspectRatio, maintainAspectRatio, onResize, devicePixelRatio, hover, events, onHover, onClick, animation, layout, legend, legendCallback, title, tooltips, elements, scales, showLines, spanGaps, cutoutPercentage, circumference, rotation, plugins, scale) {
    return new ChartOptions(responsive === void 0 ? this.responsive : responsive, responsiveAnimationDuration === void 0 ? this.responsiveAnimationDuration : responsiveAnimationDuration, aspectRatio === void 0 ? this.aspectRatio : aspectRatio, maintainAspectRatio === void 0 ? this.maintainAspectRatio : maintainAspectRatio, onResize === void 0 ? this.onResize : onResize, devicePixelRatio === void 0 ? this.devicePixelRatio : devicePixelRatio, hover === void 0 ? this.hover : hover, events === void 0 ? this.events : events, onHover === void 0 ? this.onHover : onHover, onClick === void 0 ? this.onClick : onClick, animation === void 0 ? this.animation : animation, layout === void 0 ? this.layout : layout, legend === void 0 ? this.legend : legend, legendCallback === void 0 ? this.legendCallback : legendCallback, title === void 0 ? this.title : title, tooltips === void 0 ? this.tooltips : tooltips, elements === void 0 ? this.elements : elements, scales === void 0 ? this.scales : scales, showLines === void 0 ? this.showLines : showLines, spanGaps === void 0 ? this.spanGaps : spanGaps, cutoutPercentage === void 0 ? this.cutoutPercentage : cutoutPercentage, circumference === void 0 ? this.circumference : circumference, rotation === void 0 ? this.rotation : rotation, plugins === void 0 ? this.plugins : plugins, scale === void 0 ? this.scale : scale);
  };
  ChartOptions.prototype.toString = function () {
    return 'ChartOptions(responsive=' + Kotlin.toString(this.responsive) + (', responsiveAnimationDuration=' + Kotlin.toString(this.responsiveAnimationDuration)) + (', aspectRatio=' + Kotlin.toString(this.aspectRatio)) + (', maintainAspectRatio=' + Kotlin.toString(this.maintainAspectRatio)) + (', onResize=' + Kotlin.toString(this.onResize)) + (', devicePixelRatio=' + Kotlin.toString(this.devicePixelRatio)) + (', hover=' + Kotlin.toString(this.hover)) + (', events=' + Kotlin.toString(this.events)) + (', onHover=' + Kotlin.toString(this.onHover)) + (', onClick=' + Kotlin.toString(this.onClick)) + (', animation=' + Kotlin.toString(this.animation)) + (', layout=' + Kotlin.toString(this.layout)) + (', legend=' + Kotlin.toString(this.legend)) + (', legendCallback=' + Kotlin.toString(this.legendCallback)) + (', title=' + Kotlin.toString(this.title)) + (', tooltips=' + Kotlin.toString(this.tooltips)) + (', elements=' + Kotlin.toString(this.elements)) + (', scales=' + Kotlin.toString(this.scales)) + (', showLines=' + Kotlin.toString(this.showLines)) + (', spanGaps=' + Kotlin.toString(this.spanGaps)) + (', cutoutPercentage=' + Kotlin.toString(this.cutoutPercentage)) + (', circumference=' + Kotlin.toString(this.circumference)) + (', rotation=' + Kotlin.toString(this.rotation)) + (', plugins=' + Kotlin.toString(this.plugins)) + (', scale=' + Kotlin.toString(this.scale)) + ')';
  };
  ChartOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.responsive) | 0;
    result = result * 31 + Kotlin.hashCode(this.responsiveAnimationDuration) | 0;
    result = result * 31 + Kotlin.hashCode(this.aspectRatio) | 0;
    result = result * 31 + Kotlin.hashCode(this.maintainAspectRatio) | 0;
    result = result * 31 + Kotlin.hashCode(this.onResize) | 0;
    result = result * 31 + Kotlin.hashCode(this.devicePixelRatio) | 0;
    result = result * 31 + Kotlin.hashCode(this.hover) | 0;
    result = result * 31 + Kotlin.hashCode(this.events) | 0;
    result = result * 31 + Kotlin.hashCode(this.onHover) | 0;
    result = result * 31 + Kotlin.hashCode(this.onClick) | 0;
    result = result * 31 + Kotlin.hashCode(this.animation) | 0;
    result = result * 31 + Kotlin.hashCode(this.layout) | 0;
    result = result * 31 + Kotlin.hashCode(this.legend) | 0;
    result = result * 31 + Kotlin.hashCode(this.legendCallback) | 0;
    result = result * 31 + Kotlin.hashCode(this.title) | 0;
    result = result * 31 + Kotlin.hashCode(this.tooltips) | 0;
    result = result * 31 + Kotlin.hashCode(this.elements) | 0;
    result = result * 31 + Kotlin.hashCode(this.scales) | 0;
    result = result * 31 + Kotlin.hashCode(this.showLines) | 0;
    result = result * 31 + Kotlin.hashCode(this.spanGaps) | 0;
    result = result * 31 + Kotlin.hashCode(this.cutoutPercentage) | 0;
    result = result * 31 + Kotlin.hashCode(this.circumference) | 0;
    result = result * 31 + Kotlin.hashCode(this.rotation) | 0;
    result = result * 31 + Kotlin.hashCode(this.plugins) | 0;
    result = result * 31 + Kotlin.hashCode(this.scale) | 0;
    return result;
  };
  ChartOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.responsive, other.responsive) && Kotlin.equals(this.responsiveAnimationDuration, other.responsiveAnimationDuration) && Kotlin.equals(this.aspectRatio, other.aspectRatio) && Kotlin.equals(this.maintainAspectRatio, other.maintainAspectRatio) && Kotlin.equals(this.onResize, other.onResize) && Kotlin.equals(this.devicePixelRatio, other.devicePixelRatio) && Kotlin.equals(this.hover, other.hover) && Kotlin.equals(this.events, other.events) && Kotlin.equals(this.onHover, other.onHover) && Kotlin.equals(this.onClick, other.onClick) && Kotlin.equals(this.animation, other.animation) && Kotlin.equals(this.layout, other.layout) && Kotlin.equals(this.legend, other.legend) && Kotlin.equals(this.legendCallback, other.legendCallback) && Kotlin.equals(this.title, other.title) && Kotlin.equals(this.tooltips, other.tooltips) && Kotlin.equals(this.elements, other.elements) && Kotlin.equals(this.scales, other.scales) && Kotlin.equals(this.showLines, other.showLines) && Kotlin.equals(this.spanGaps, other.spanGaps) && Kotlin.equals(this.cutoutPercentage, other.cutoutPercentage) && Kotlin.equals(this.circumference, other.circumference) && Kotlin.equals(this.rotation, other.rotation) && Kotlin.equals(this.plugins, other.plugins) && Kotlin.equals(this.scale, other.scale)))));
  };
  function toJs_17($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    $receiver_0.responsive = $receiver.responsive;
    $receiver_0.responsiveAnimationDuration = $receiver.responsiveAnimationDuration;
    $receiver_0.aspectRatio = $receiver.aspectRatio;
    $receiver_0.maintainAspectRatio = $receiver.maintainAspectRatio;
    if ($receiver.onResize != null)
      $receiver_0.onResize = $receiver.onResize;
    if ($receiver.devicePixelRatio != null)
      $receiver_0.devicePixelRatio = $receiver.devicePixelRatio;
    if ($receiver.hover != null)
      $receiver_0.hover = toJs($receiver.hover);
    if ($receiver.events != null) {
      $receiver_0.events = copyToArray($receiver.events);
    }if ($receiver.onHover != null)
      $receiver_0.onHover = $receiver.onHover;
    if ($receiver.onClick != null)
      $receiver_0.onClick = $receiver.onClick;
    if ($receiver.animation != null)
      $receiver_0.animation = toJs_0($receiver.animation);
    if ($receiver.layout != null)
      $receiver_0.layout = toJs_2($receiver.layout);
    if ($receiver.legend != null)
      $receiver_0.legend = toJs_4($receiver.legend);
    if ($receiver.legendCallback != null)
      $receiver_0.legendCallback = $receiver.legendCallback;
    if ($receiver.title != null)
      $receiver_0.title = toJs_5($receiver.title, i18nTranslator);
    if ($receiver.tooltips != null)
      $receiver_0.tooltips = toJs_7($receiver.tooltips);
    if ($receiver.elements != null)
      $receiver_0.elements = toJs_12($receiver.elements);
    if ($receiver.scales != null)
      $receiver_0.scales = toJs_16($receiver.scales, i18nTranslator);
    if ($receiver.showLines != null)
      $receiver_0.showLines = $receiver.showLines;
    if ($receiver.spanGaps != null)
      $receiver_0.spanGaps = $receiver.spanGaps;
    if ($receiver.cutoutPercentage != null)
      $receiver_0.cutoutPercentage = $receiver.cutoutPercentage;
    if ($receiver.circumference != null)
      $receiver_0.circumference = $receiver.circumference;
    if ($receiver.rotation != null)
      $receiver_0.rotation = $receiver.rotation;
    if ($receiver.plugins != null)
      $receiver_0.plugins = $receiver.plugins;
    if ($receiver.scale != null)
      $receiver_0.scale = $receiver.scale;
    return $receiver_0;
  }
  function DataSets(cubicInterpolationMode, backgroundColor, borderWidth, borderColor, borderCapStyle, borderDash, borderDashOffset, borderJoinStyle, borderSkipped, data, fill, hoverBackgroundColor, hoverBorderColor, hoverBorderWidth, label, lineTension, steppedLine, pointBorderColor, pointBackgroundColor, pointBorderWidth, pointRadius, pointHoverRadius, pointHitRadius, pointHoverBackgroundColor, pointHoverBorderColor, pointHoverBorderWidth, pointStyle, xAxisID, yAxisID, type, hidden, hideInLegendAndTooltip, showLine, stack, spanGaps, barPercentage, barThickness, borderAlign, categoryPercentage, hitRadius, hoverRadius, maxBarThickness, minBarLegth, order, pointRotation, radius, rotation, weight) {
    if (cubicInterpolationMode === void 0)
      cubicInterpolationMode = null;
    if (backgroundColor === void 0)
      backgroundColor = null;
    if (borderWidth === void 0)
      borderWidth = null;
    if (borderColor === void 0)
      borderColor = null;
    if (borderCapStyle === void 0)
      borderCapStyle = null;
    if (borderDash === void 0)
      borderDash = null;
    if (borderDashOffset === void 0)
      borderDashOffset = null;
    if (borderJoinStyle === void 0)
      borderJoinStyle = null;
    if (borderSkipped === void 0)
      borderSkipped = null;
    if (data === void 0)
      data = null;
    if (fill === void 0)
      fill = null;
    if (hoverBackgroundColor === void 0)
      hoverBackgroundColor = null;
    if (hoverBorderColor === void 0)
      hoverBorderColor = null;
    if (hoverBorderWidth === void 0)
      hoverBorderWidth = null;
    if (label === void 0)
      label = null;
    if (lineTension === void 0)
      lineTension = null;
    if (steppedLine === void 0)
      steppedLine = null;
    if (pointBorderColor === void 0)
      pointBorderColor = null;
    if (pointBackgroundColor === void 0)
      pointBackgroundColor = null;
    if (pointBorderWidth === void 0)
      pointBorderWidth = null;
    if (pointRadius === void 0)
      pointRadius = null;
    if (pointHoverRadius === void 0)
      pointHoverRadius = null;
    if (pointHitRadius === void 0)
      pointHitRadius = null;
    if (pointHoverBackgroundColor === void 0)
      pointHoverBackgroundColor = null;
    if (pointHoverBorderColor === void 0)
      pointHoverBorderColor = null;
    if (pointHoverBorderWidth === void 0)
      pointHoverBorderWidth = null;
    if (pointStyle === void 0)
      pointStyle = null;
    if (xAxisID === void 0)
      xAxisID = null;
    if (yAxisID === void 0)
      yAxisID = null;
    if (type === void 0)
      type = null;
    if (hidden === void 0)
      hidden = null;
    if (hideInLegendAndTooltip === void 0)
      hideInLegendAndTooltip = null;
    if (showLine === void 0)
      showLine = null;
    if (stack === void 0)
      stack = null;
    if (spanGaps === void 0)
      spanGaps = null;
    if (barPercentage === void 0)
      barPercentage = null;
    if (barThickness === void 0)
      barThickness = null;
    if (borderAlign === void 0)
      borderAlign = null;
    if (categoryPercentage === void 0)
      categoryPercentage = null;
    if (hitRadius === void 0)
      hitRadius = null;
    if (hoverRadius === void 0)
      hoverRadius = null;
    if (maxBarThickness === void 0)
      maxBarThickness = null;
    if (minBarLegth === void 0)
      minBarLegth = null;
    if (order === void 0)
      order = null;
    if (pointRotation === void 0)
      pointRotation = null;
    if (radius === void 0)
      radius = null;
    if (rotation === void 0)
      rotation = null;
    if (weight === void 0)
      weight = null;
    this.cubicInterpolationMode = cubicInterpolationMode;
    this.backgroundColor = backgroundColor;
    this.borderWidth = borderWidth;
    this.borderColor = borderColor;
    this.borderCapStyle = borderCapStyle;
    this.borderDash = borderDash;
    this.borderDashOffset = borderDashOffset;
    this.borderJoinStyle = borderJoinStyle;
    this.borderSkipped = borderSkipped;
    this.data = data;
    this.fill = fill;
    this.hoverBackgroundColor = hoverBackgroundColor;
    this.hoverBorderColor = hoverBorderColor;
    this.hoverBorderWidth = hoverBorderWidth;
    this.label = label;
    this.lineTension = lineTension;
    this.steppedLine = steppedLine;
    this.pointBorderColor = pointBorderColor;
    this.pointBackgroundColor = pointBackgroundColor;
    this.pointBorderWidth = pointBorderWidth;
    this.pointRadius = pointRadius;
    this.pointHoverRadius = pointHoverRadius;
    this.pointHitRadius = pointHitRadius;
    this.pointHoverBackgroundColor = pointHoverBackgroundColor;
    this.pointHoverBorderColor = pointHoverBorderColor;
    this.pointHoverBorderWidth = pointHoverBorderWidth;
    this.pointStyle = pointStyle;
    this.xAxisID = xAxisID;
    this.yAxisID = yAxisID;
    this.type = type;
    this.hidden = hidden;
    this.hideInLegendAndTooltip = hideInLegendAndTooltip;
    this.showLine = showLine;
    this.stack = stack;
    this.spanGaps = spanGaps;
    this.barPercentage = barPercentage;
    this.barThickness = barThickness;
    this.borderAlign = borderAlign;
    this.categoryPercentage = categoryPercentage;
    this.hitRadius = hitRadius;
    this.hoverRadius = hoverRadius;
    this.maxBarThickness = maxBarThickness;
    this.minBarLegth = minBarLegth;
    this.order = order;
    this.pointRotation = pointRotation;
    this.radius = radius;
    this.rotation = rotation;
    this.weight = weight;
  }
  DataSets.$metadata$ = {kind: Kind_CLASS, simpleName: 'DataSets', interfaces: []};
  DataSets.prototype.component1 = function () {
    return this.cubicInterpolationMode;
  };
  DataSets.prototype.component2 = function () {
    return this.backgroundColor;
  };
  DataSets.prototype.component3 = function () {
    return this.borderWidth;
  };
  DataSets.prototype.component4 = function () {
    return this.borderColor;
  };
  DataSets.prototype.component5 = function () {
    return this.borderCapStyle;
  };
  DataSets.prototype.component6 = function () {
    return this.borderDash;
  };
  DataSets.prototype.component7 = function () {
    return this.borderDashOffset;
  };
  DataSets.prototype.component8 = function () {
    return this.borderJoinStyle;
  };
  DataSets.prototype.component9 = function () {
    return this.borderSkipped;
  };
  DataSets.prototype.component10 = function () {
    return this.data;
  };
  DataSets.prototype.component11 = function () {
    return this.fill;
  };
  DataSets.prototype.component12 = function () {
    return this.hoverBackgroundColor;
  };
  DataSets.prototype.component13 = function () {
    return this.hoverBorderColor;
  };
  DataSets.prototype.component14 = function () {
    return this.hoverBorderWidth;
  };
  DataSets.prototype.component15 = function () {
    return this.label;
  };
  DataSets.prototype.component16 = function () {
    return this.lineTension;
  };
  DataSets.prototype.component17 = function () {
    return this.steppedLine;
  };
  DataSets.prototype.component18 = function () {
    return this.pointBorderColor;
  };
  DataSets.prototype.component19 = function () {
    return this.pointBackgroundColor;
  };
  DataSets.prototype.component20 = function () {
    return this.pointBorderWidth;
  };
  DataSets.prototype.component21 = function () {
    return this.pointRadius;
  };
  DataSets.prototype.component22 = function () {
    return this.pointHoverRadius;
  };
  DataSets.prototype.component23 = function () {
    return this.pointHitRadius;
  };
  DataSets.prototype.component24 = function () {
    return this.pointHoverBackgroundColor;
  };
  DataSets.prototype.component25 = function () {
    return this.pointHoverBorderColor;
  };
  DataSets.prototype.component26 = function () {
    return this.pointHoverBorderWidth;
  };
  DataSets.prototype.component27 = function () {
    return this.pointStyle;
  };
  DataSets.prototype.component28 = function () {
    return this.xAxisID;
  };
  DataSets.prototype.component29 = function () {
    return this.yAxisID;
  };
  DataSets.prototype.component30 = function () {
    return this.type;
  };
  DataSets.prototype.component31 = function () {
    return this.hidden;
  };
  DataSets.prototype.component32 = function () {
    return this.hideInLegendAndTooltip;
  };
  DataSets.prototype.component33 = function () {
    return this.showLine;
  };
  DataSets.prototype.component34 = function () {
    return this.stack;
  };
  DataSets.prototype.component35 = function () {
    return this.spanGaps;
  };
  DataSets.prototype.component36 = function () {
    return this.barPercentage;
  };
  DataSets.prototype.component37 = function () {
    return this.barThickness;
  };
  DataSets.prototype.component38 = function () {
    return this.borderAlign;
  };
  DataSets.prototype.component39 = function () {
    return this.categoryPercentage;
  };
  DataSets.prototype.component40 = function () {
    return this.hitRadius;
  };
  DataSets.prototype.component41 = function () {
    return this.hoverRadius;
  };
  DataSets.prototype.component42 = function () {
    return this.maxBarThickness;
  };
  DataSets.prototype.component43 = function () {
    return this.minBarLegth;
  };
  DataSets.prototype.component44 = function () {
    return this.order;
  };
  DataSets.prototype.component45 = function () {
    return this.pointRotation;
  };
  DataSets.prototype.component46 = function () {
    return this.radius;
  };
  DataSets.prototype.component47 = function () {
    return this.rotation;
  };
  DataSets.prototype.component48 = function () {
    return this.weight;
  };
  DataSets.prototype.copy_2rvq89$ = function (cubicInterpolationMode, backgroundColor, borderWidth, borderColor, borderCapStyle, borderDash, borderDashOffset, borderJoinStyle, borderSkipped, data, fill, hoverBackgroundColor, hoverBorderColor, hoverBorderWidth, label, lineTension, steppedLine, pointBorderColor, pointBackgroundColor, pointBorderWidth, pointRadius, pointHoverRadius, pointHitRadius, pointHoverBackgroundColor, pointHoverBorderColor, pointHoverBorderWidth, pointStyle, xAxisID, yAxisID, type, hidden, hideInLegendAndTooltip, showLine, stack, spanGaps, barPercentage, barThickness, borderAlign, categoryPercentage, hitRadius, hoverRadius, maxBarThickness, minBarLegth, order, pointRotation, radius, rotation, weight) {
    return new DataSets(cubicInterpolationMode === void 0 ? this.cubicInterpolationMode : cubicInterpolationMode, backgroundColor === void 0 ? this.backgroundColor : backgroundColor, borderWidth === void 0 ? this.borderWidth : borderWidth, borderColor === void 0 ? this.borderColor : borderColor, borderCapStyle === void 0 ? this.borderCapStyle : borderCapStyle, borderDash === void 0 ? this.borderDash : borderDash, borderDashOffset === void 0 ? this.borderDashOffset : borderDashOffset, borderJoinStyle === void 0 ? this.borderJoinStyle : borderJoinStyle, borderSkipped === void 0 ? this.borderSkipped : borderSkipped, data === void 0 ? this.data : data, fill === void 0 ? this.fill : fill, hoverBackgroundColor === void 0 ? this.hoverBackgroundColor : hoverBackgroundColor, hoverBorderColor === void 0 ? this.hoverBorderColor : hoverBorderColor, hoverBorderWidth === void 0 ? this.hoverBorderWidth : hoverBorderWidth, label === void 0 ? this.label : label, lineTension === void 0 ? this.lineTension : lineTension, steppedLine === void 0 ? this.steppedLine : steppedLine, pointBorderColor === void 0 ? this.pointBorderColor : pointBorderColor, pointBackgroundColor === void 0 ? this.pointBackgroundColor : pointBackgroundColor, pointBorderWidth === void 0 ? this.pointBorderWidth : pointBorderWidth, pointRadius === void 0 ? this.pointRadius : pointRadius, pointHoverRadius === void 0 ? this.pointHoverRadius : pointHoverRadius, pointHitRadius === void 0 ? this.pointHitRadius : pointHitRadius, pointHoverBackgroundColor === void 0 ? this.pointHoverBackgroundColor : pointHoverBackgroundColor, pointHoverBorderColor === void 0 ? this.pointHoverBorderColor : pointHoverBorderColor, pointHoverBorderWidth === void 0 ? this.pointHoverBorderWidth : pointHoverBorderWidth, pointStyle === void 0 ? this.pointStyle : pointStyle, xAxisID === void 0 ? this.xAxisID : xAxisID, yAxisID === void 0 ? this.yAxisID : yAxisID, type === void 0 ? this.type : type, hidden === void 0 ? this.hidden : hidden, hideInLegendAndTooltip === void 0 ? this.hideInLegendAndTooltip : hideInLegendAndTooltip, showLine === void 0 ? this.showLine : showLine, stack === void 0 ? this.stack : stack, spanGaps === void 0 ? this.spanGaps : spanGaps, barPercentage === void 0 ? this.barPercentage : barPercentage, barThickness === void 0 ? this.barThickness : barThickness, borderAlign === void 0 ? this.borderAlign : borderAlign, categoryPercentage === void 0 ? this.categoryPercentage : categoryPercentage, hitRadius === void 0 ? this.hitRadius : hitRadius, hoverRadius === void 0 ? this.hoverRadius : hoverRadius, maxBarThickness === void 0 ? this.maxBarThickness : maxBarThickness, minBarLegth === void 0 ? this.minBarLegth : minBarLegth, order === void 0 ? this.order : order, pointRotation === void 0 ? this.pointRotation : pointRotation, radius === void 0 ? this.radius : radius, rotation === void 0 ? this.rotation : rotation, weight === void 0 ? this.weight : weight);
  };
  DataSets.prototype.toString = function () {
    return 'DataSets(cubicInterpolationMode=' + Kotlin.toString(this.cubicInterpolationMode) + (', backgroundColor=' + Kotlin.toString(this.backgroundColor)) + (', borderWidth=' + Kotlin.toString(this.borderWidth)) + (', borderColor=' + Kotlin.toString(this.borderColor)) + (', borderCapStyle=' + Kotlin.toString(this.borderCapStyle)) + (', borderDash=' + Kotlin.toString(this.borderDash)) + (', borderDashOffset=' + Kotlin.toString(this.borderDashOffset)) + (', borderJoinStyle=' + Kotlin.toString(this.borderJoinStyle)) + (', borderSkipped=' + Kotlin.toString(this.borderSkipped)) + (', data=' + Kotlin.toString(this.data)) + (', fill=' + Kotlin.toString(this.fill)) + (', hoverBackgroundColor=' + Kotlin.toString(this.hoverBackgroundColor)) + (', hoverBorderColor=' + Kotlin.toString(this.hoverBorderColor)) + (', hoverBorderWidth=' + Kotlin.toString(this.hoverBorderWidth)) + (', label=' + Kotlin.toString(this.label)) + (', lineTension=' + Kotlin.toString(this.lineTension)) + (', steppedLine=' + Kotlin.toString(this.steppedLine)) + (', pointBorderColor=' + Kotlin.toString(this.pointBorderColor)) + (', pointBackgroundColor=' + Kotlin.toString(this.pointBackgroundColor)) + (', pointBorderWidth=' + Kotlin.toString(this.pointBorderWidth)) + (', pointRadius=' + Kotlin.toString(this.pointRadius)) + (', pointHoverRadius=' + Kotlin.toString(this.pointHoverRadius)) + (', pointHitRadius=' + Kotlin.toString(this.pointHitRadius)) + (', pointHoverBackgroundColor=' + Kotlin.toString(this.pointHoverBackgroundColor)) + (', pointHoverBorderColor=' + Kotlin.toString(this.pointHoverBorderColor)) + (', pointHoverBorderWidth=' + Kotlin.toString(this.pointHoverBorderWidth)) + (', pointStyle=' + Kotlin.toString(this.pointStyle)) + (', xAxisID=' + Kotlin.toString(this.xAxisID)) + (', yAxisID=' + Kotlin.toString(this.yAxisID)) + (', type=' + Kotlin.toString(this.type)) + (', hidden=' + Kotlin.toString(this.hidden)) + (', hideInLegendAndTooltip=' + Kotlin.toString(this.hideInLegendAndTooltip)) + (', showLine=' + Kotlin.toString(this.showLine)) + (', stack=' + Kotlin.toString(this.stack)) + (', spanGaps=' + Kotlin.toString(this.spanGaps)) + (', barPercentage=' + Kotlin.toString(this.barPercentage)) + (', barThickness=' + Kotlin.toString(this.barThickness)) + (', borderAlign=' + Kotlin.toString(this.borderAlign)) + (', categoryPercentage=' + Kotlin.toString(this.categoryPercentage)) + (', hitRadius=' + Kotlin.toString(this.hitRadius)) + (', hoverRadius=' + Kotlin.toString(this.hoverRadius)) + (', maxBarThickness=' + Kotlin.toString(this.maxBarThickness)) + (', minBarLegth=' + Kotlin.toString(this.minBarLegth)) + (', order=' + Kotlin.toString(this.order)) + (', pointRotation=' + Kotlin.toString(this.pointRotation)) + (', radius=' + Kotlin.toString(this.radius)) + (', rotation=' + Kotlin.toString(this.rotation)) + (', weight=' + Kotlin.toString(this.weight)) + ')';
  };
  DataSets.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.cubicInterpolationMode) | 0;
    result = result * 31 + Kotlin.hashCode(this.backgroundColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderCapStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderDash) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderDashOffset) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderJoinStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderSkipped) | 0;
    result = result * 31 + Kotlin.hashCode(this.data) | 0;
    result = result * 31 + Kotlin.hashCode(this.fill) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBackgroundColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBorderColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBorderWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.label) | 0;
    result = result * 31 + Kotlin.hashCode(this.lineTension) | 0;
    result = result * 31 + Kotlin.hashCode(this.steppedLine) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointBorderColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointBackgroundColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointBorderWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointHoverRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointHitRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointHoverBackgroundColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointHoverBorderColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointHoverBorderWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.xAxisID) | 0;
    result = result * 31 + Kotlin.hashCode(this.yAxisID) | 0;
    result = result * 31 + Kotlin.hashCode(this.type) | 0;
    result = result * 31 + Kotlin.hashCode(this.hidden) | 0;
    result = result * 31 + Kotlin.hashCode(this.hideInLegendAndTooltip) | 0;
    result = result * 31 + Kotlin.hashCode(this.showLine) | 0;
    result = result * 31 + Kotlin.hashCode(this.stack) | 0;
    result = result * 31 + Kotlin.hashCode(this.spanGaps) | 0;
    result = result * 31 + Kotlin.hashCode(this.barPercentage) | 0;
    result = result * 31 + Kotlin.hashCode(this.barThickness) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderAlign) | 0;
    result = result * 31 + Kotlin.hashCode(this.categoryPercentage) | 0;
    result = result * 31 + Kotlin.hashCode(this.hitRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.maxBarThickness) | 0;
    result = result * 31 + Kotlin.hashCode(this.minBarLegth) | 0;
    result = result * 31 + Kotlin.hashCode(this.order) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointRotation) | 0;
    result = result * 31 + Kotlin.hashCode(this.radius) | 0;
    result = result * 31 + Kotlin.hashCode(this.rotation) | 0;
    result = result * 31 + Kotlin.hashCode(this.weight) | 0;
    return result;
  };
  DataSets.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.cubicInterpolationMode, other.cubicInterpolationMode) && Kotlin.equals(this.backgroundColor, other.backgroundColor) && Kotlin.equals(this.borderWidth, other.borderWidth) && Kotlin.equals(this.borderColor, other.borderColor) && Kotlin.equals(this.borderCapStyle, other.borderCapStyle) && Kotlin.equals(this.borderDash, other.borderDash) && Kotlin.equals(this.borderDashOffset, other.borderDashOffset) && Kotlin.equals(this.borderJoinStyle, other.borderJoinStyle) && Kotlin.equals(this.borderSkipped, other.borderSkipped) && Kotlin.equals(this.data, other.data) && Kotlin.equals(this.fill, other.fill) && Kotlin.equals(this.hoverBackgroundColor, other.hoverBackgroundColor) && Kotlin.equals(this.hoverBorderColor, other.hoverBorderColor) && Kotlin.equals(this.hoverBorderWidth, other.hoverBorderWidth) && Kotlin.equals(this.label, other.label) && Kotlin.equals(this.lineTension, other.lineTension) && Kotlin.equals(this.steppedLine, other.steppedLine) && Kotlin.equals(this.pointBorderColor, other.pointBorderColor) && Kotlin.equals(this.pointBackgroundColor, other.pointBackgroundColor) && Kotlin.equals(this.pointBorderWidth, other.pointBorderWidth) && Kotlin.equals(this.pointRadius, other.pointRadius) && Kotlin.equals(this.pointHoverRadius, other.pointHoverRadius) && Kotlin.equals(this.pointHitRadius, other.pointHitRadius) && Kotlin.equals(this.pointHoverBackgroundColor, other.pointHoverBackgroundColor) && Kotlin.equals(this.pointHoverBorderColor, other.pointHoverBorderColor) && Kotlin.equals(this.pointHoverBorderWidth, other.pointHoverBorderWidth) && Kotlin.equals(this.pointStyle, other.pointStyle) && Kotlin.equals(this.xAxisID, other.xAxisID) && Kotlin.equals(this.yAxisID, other.yAxisID) && Kotlin.equals(this.type, other.type) && Kotlin.equals(this.hidden, other.hidden) && Kotlin.equals(this.hideInLegendAndTooltip, other.hideInLegendAndTooltip) && Kotlin.equals(this.showLine, other.showLine) && Kotlin.equals(this.stack, other.stack) && Kotlin.equals(this.spanGaps, other.spanGaps) && Kotlin.equals(this.barPercentage, other.barPercentage) && Kotlin.equals(this.barThickness, other.barThickness) && Kotlin.equals(this.borderAlign, other.borderAlign) && Kotlin.equals(this.categoryPercentage, other.categoryPercentage) && Kotlin.equals(this.hitRadius, other.hitRadius) && Kotlin.equals(this.hoverRadius, other.hoverRadius) && Kotlin.equals(this.maxBarThickness, other.maxBarThickness) && Kotlin.equals(this.minBarLegth, other.minBarLegth) && Kotlin.equals(this.order, other.order) && Kotlin.equals(this.pointRotation, other.pointRotation) && Kotlin.equals(this.radius, other.radius) && Kotlin.equals(this.rotation, other.rotation) && Kotlin.equals(this.weight, other.weight)))));
  };
  function toJs_18($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    if ($receiver.cubicInterpolationMode != null)
      $receiver_0.cubicInterpolationMode = $receiver.cubicInterpolationMode.mode_8be2vx$;
    if ($receiver.backgroundColor != null) {
      var $receiver_1 = $receiver.backgroundColor;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver_1, 10));
      var tmp$;
      tmp$ = $receiver_1.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(item.asString());
      }
      $receiver_0.backgroundColor = checkSingleValue(copyToArray(destination));
    }if ($receiver.borderWidth != null) {
      $receiver_0.borderWidth = checkSingleValue(copyToArray($receiver.borderWidth));
    }if ($receiver.borderColor != null) {
      var $receiver_2 = $receiver.borderColor;
      var destination_0 = ArrayList_init(collectionSizeOrDefault($receiver_2, 10));
      var tmp$_0;
      tmp$_0 = $receiver_2.iterator();
      while (tmp$_0.hasNext()) {
        var item_0 = tmp$_0.next();
        destination_0.add_11rb$(item_0.asString());
      }
      $receiver_0.borderColor = checkSingleValue(copyToArray(destination_0));
    }if ($receiver.borderCapStyle != null) {
      var $receiver_3 = $receiver.borderCapStyle;
      var destination_1 = ArrayList_init(collectionSizeOrDefault($receiver_3, 10));
      var tmp$_1;
      tmp$_1 = $receiver_3.iterator();
      while (tmp$_1.hasNext()) {
        var item_1 = tmp$_1.next();
        destination_1.add_11rb$(item_1.mode_8be2vx$);
      }
      $receiver_0.borderCapStyle = checkSingleValue(copyToArray(destination_1));
    }if ($receiver.borderDash != null) {
      $receiver_0.borderDash = copyToArray($receiver.borderDash);
    }if ($receiver.borderDashOffset != null)
      $receiver_0.borderDashOffset = $receiver.borderDashOffset;
    if ($receiver.borderJoinStyle != null) {
      var $receiver_4 = $receiver.borderJoinStyle;
      var destination_2 = ArrayList_init(collectionSizeOrDefault($receiver_4, 10));
      var tmp$_2;
      tmp$_2 = $receiver_4.iterator();
      while (tmp$_2.hasNext()) {
        var item_2 = tmp$_2.next();
        destination_2.add_11rb$(item_2.mode_8be2vx$);
      }
      $receiver_0.borderJoinStyle = checkSingleValue(copyToArray(destination_2));
    }if ($receiver.borderSkipped != null) {
      var $receiver_5 = $receiver.borderSkipped;
      var destination_3 = ArrayList_init(collectionSizeOrDefault($receiver_5, 10));
      var tmp$_3;
      tmp$_3 = $receiver_5.iterator();
      while (tmp$_3.hasNext()) {
        var item_3 = tmp$_3.next();
        destination_3.add_11rb$(item_3.position_8be2vx$);
      }
      $receiver_0.borderSkipped = checkSingleValue(copyToArray(destination_3));
    }if ($receiver.data != null) {
      $receiver_0.data = copyToArray($receiver.data);
    }if ($receiver.fill != null)
      $receiver_0.fill = $receiver.fill;
    if ($receiver.hoverBackgroundColor != null) {
      var $receiver_6 = $receiver.hoverBackgroundColor;
      var destination_4 = ArrayList_init(collectionSizeOrDefault($receiver_6, 10));
      var tmp$_4;
      tmp$_4 = $receiver_6.iterator();
      while (tmp$_4.hasNext()) {
        var item_4 = tmp$_4.next();
        destination_4.add_11rb$(item_4.asString());
      }
      $receiver_0.hoverBackgroundColor = checkSingleValue(copyToArray(destination_4));
    }if ($receiver.hoverBorderColor != null) {
      var $receiver_7 = $receiver.hoverBorderColor;
      var destination_5 = ArrayList_init(collectionSizeOrDefault($receiver_7, 10));
      var tmp$_5;
      tmp$_5 = $receiver_7.iterator();
      while (tmp$_5.hasNext()) {
        var item_5 = tmp$_5.next();
        destination_5.add_11rb$(item_5.asString());
      }
      $receiver_0.hoverBorderColor = checkSingleValue(copyToArray(destination_5));
    }if ($receiver.hoverBorderWidth != null) {
      $receiver_0.hoverBorderWidth = checkSingleValue(copyToArray($receiver.hoverBorderWidth));
    }if ($receiver.label != null)
      $receiver_0.label = i18nTranslator($receiver.label);
    if ($receiver.lineTension != null)
      $receiver_0.lineTension = $receiver.lineTension;
    if ($receiver.steppedLine != null)
      $receiver_0.steppedLine = $receiver.steppedLine;
    if ($receiver.pointBorderColor != null) {
      var $receiver_8 = $receiver.pointBorderColor;
      var destination_6 = ArrayList_init(collectionSizeOrDefault($receiver_8, 10));
      var tmp$_6;
      tmp$_6 = $receiver_8.iterator();
      while (tmp$_6.hasNext()) {
        var item_6 = tmp$_6.next();
        destination_6.add_11rb$(item_6.asString());
      }
      $receiver_0.pointBorderColor = checkSingleValue(copyToArray(destination_6));
    }if ($receiver.pointBackgroundColor != null) {
      var $receiver_9 = $receiver.pointBackgroundColor;
      var destination_7 = ArrayList_init(collectionSizeOrDefault($receiver_9, 10));
      var tmp$_7;
      tmp$_7 = $receiver_9.iterator();
      while (tmp$_7.hasNext()) {
        var item_7 = tmp$_7.next();
        destination_7.add_11rb$(item_7.asString());
      }
      $receiver_0.pointBackgroundColor = checkSingleValue(copyToArray(destination_7));
    }if ($receiver.pointBorderWidth != null) {
      $receiver_0.pointBorderWidth = checkSingleValue(copyToArray($receiver.pointBorderWidth));
    }if ($receiver.pointRadius != null) {
      $receiver_0.pointRadius = checkSingleValue(copyToArray($receiver.pointRadius));
    }if ($receiver.pointHoverRadius != null) {
      $receiver_0.pointHoverRadius = checkSingleValue(copyToArray($receiver.pointHoverRadius));
    }if ($receiver.pointHitRadius != null) {
      $receiver_0.pointHitRadius = checkSingleValue(copyToArray($receiver.pointHitRadius));
    }if ($receiver.pointHoverBackgroundColor != null) {
      var $receiver_10 = $receiver.pointHoverBackgroundColor;
      var destination_8 = ArrayList_init(collectionSizeOrDefault($receiver_10, 10));
      var tmp$_8;
      tmp$_8 = $receiver_10.iterator();
      while (tmp$_8.hasNext()) {
        var item_8 = tmp$_8.next();
        destination_8.add_11rb$(item_8.asString());
      }
      $receiver_0.pointHoverBackgroundColor = checkSingleValue(copyToArray(destination_8));
    }if ($receiver.pointHoverBorderColor != null) {
      var $receiver_11 = $receiver.pointHoverBorderColor;
      var destination_9 = ArrayList_init(collectionSizeOrDefault($receiver_11, 10));
      var tmp$_9;
      tmp$_9 = $receiver_11.iterator();
      while (tmp$_9.hasNext()) {
        var item_9 = tmp$_9.next();
        destination_9.add_11rb$(item_9.asString());
      }
      $receiver_0.pointHoverBorderColor = checkSingleValue(copyToArray(destination_9));
    }if ($receiver.pointHoverBorderWidth != null) {
      $receiver_0.pointHoverBorderWidth = checkSingleValue(copyToArray($receiver.pointHoverBorderWidth));
    }if ($receiver.pointStyle != null) {
      var $receiver_12 = $receiver.pointStyle;
      var destination_10 = ArrayList_init(collectionSizeOrDefault($receiver_12, 10));
      var tmp$_10;
      tmp$_10 = $receiver_12.iterator();
      while (tmp$_10.hasNext()) {
        var item_10 = tmp$_10.next();
        destination_10.add_11rb$(item_10.style_8be2vx$);
      }
      $receiver_0.pointStyle = checkSingleValue(copyToArray(destination_10));
    }if ($receiver.xAxisID != null)
      $receiver_0.xAxisID = $receiver.xAxisID;
    if ($receiver.yAxisID != null)
      $receiver_0.yAxisID = $receiver.yAxisID;
    if ($receiver.type != null)
      $receiver_0.type = $receiver.type.type_8be2vx$;
    if ($receiver.hidden != null)
      $receiver_0.hidden = $receiver.hidden;
    if ($receiver.hideInLegendAndTooltip != null)
      $receiver_0.hideInLegendAndTooltip = $receiver.hideInLegendAndTooltip;
    if ($receiver.showLine != null)
      $receiver_0.showLine = $receiver.showLine;
    if ($receiver.stack != null)
      $receiver_0.stack = $receiver.stack;
    if ($receiver.spanGaps != null)
      $receiver_0.spanGaps = $receiver.spanGaps;
    if ($receiver.barPercentage != null)
      $receiver_0.barPercentage = $receiver.barPercentage;
    if ($receiver.barThickness != null)
      $receiver_0.barThickness = $receiver.barThickness;
    if ($receiver.borderAlign != null)
      $receiver_0.borderAlign = $receiver.borderAlign;
    if ($receiver.categoryPercentage != null)
      $receiver_0.categoryPercentage = $receiver.categoryPercentage;
    if ($receiver.hitRadius != null) {
      $receiver_0.hitRadius = checkSingleValue(copyToArray($receiver.hitRadius));
    }if ($receiver.hoverRadius != null)
      $receiver_0.hoverRadius = $receiver.hoverRadius;
    if ($receiver.maxBarThickness != null)
      $receiver_0.maxBarThickness = $receiver.maxBarThickness;
    if ($receiver.minBarLegth != null)
      $receiver_0.minBarLegth = $receiver.minBarLegth;
    if ($receiver.order != null)
      $receiver_0.order = $receiver.order;
    if ($receiver.pointRotation != null) {
      $receiver_0.pointRotation = checkSingleValue(copyToArray($receiver.pointRotation));
    }if ($receiver.radius != null) {
      $receiver_0.radius = checkSingleValue(copyToArray($receiver.radius));
    }if ($receiver.rotation != null) {
      $receiver_0.rotation = checkSingleValue(copyToArray($receiver.rotation));
    }if ($receiver.weight != null)
      $receiver_0.weight = $receiver.weight;
    return $receiver_0;
  }
  function Configuration(type, dataSets, labels, options, plugins) {
    if (labels === void 0)
      labels = null;
    if (options === void 0)
      options = null;
    if (plugins === void 0)
      plugins = null;
    this.type = type;
    this.dataSets = dataSets;
    this.labels = labels;
    this.options = options;
    this.plugins = plugins;
  }
  Configuration.$metadata$ = {kind: Kind_CLASS, simpleName: 'Configuration', interfaces: []};
  Configuration.prototype.component1 = function () {
    return this.type;
  };
  Configuration.prototype.component2 = function () {
    return this.dataSets;
  };
  Configuration.prototype.component3 = function () {
    return this.labels;
  };
  Configuration.prototype.component4 = function () {
    return this.options;
  };
  Configuration.prototype.component5 = function () {
    return this.plugins;
  };
  Configuration.prototype.copy_5ehqcd$ = function (type, dataSets, labels, options, plugins) {
    return new Configuration(type === void 0 ? this.type : type, dataSets === void 0 ? this.dataSets : dataSets, labels === void 0 ? this.labels : labels, options === void 0 ? this.options : options, plugins === void 0 ? this.plugins : plugins);
  };
  Configuration.prototype.toString = function () {
    return 'Configuration(type=' + Kotlin.toString(this.type) + (', dataSets=' + Kotlin.toString(this.dataSets)) + (', labels=' + Kotlin.toString(this.labels)) + (', options=' + Kotlin.toString(this.options)) + (', plugins=' + Kotlin.toString(this.plugins)) + ')';
  };
  Configuration.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.type) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataSets) | 0;
    result = result * 31 + Kotlin.hashCode(this.labels) | 0;
    result = result * 31 + Kotlin.hashCode(this.options) | 0;
    result = result * 31 + Kotlin.hashCode(this.plugins) | 0;
    return result;
  };
  Configuration.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.type, other.type) && Kotlin.equals(this.dataSets, other.dataSets) && Kotlin.equals(this.labels, other.labels) && Kotlin.equals(this.options, other.options) && Kotlin.equals(this.plugins, other.plugins)))));
  };
  function toJs_19($receiver, i18nTranslator) {
    var tmp$;
    var $receiver_0 = new Object_init();
    $receiver_0.type = $receiver.type.type_8be2vx$;
    var $receiver_1 = new Object_init();
    if ($receiver.labels != null) {
      var $receiver_2 = $receiver.labels;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver_2, 10));
      var tmp$_0;
      tmp$_0 = $receiver_2.iterator();
      while (tmp$_0.hasNext()) {
        var item = tmp$_0.next();
        destination.add_11rb$(i18nTranslator(item));
      }
      $receiver_1.labels = copyToArray(destination);
    }var $receiver_3 = $receiver.dataSets;
    var destination_0 = ArrayList_init(collectionSizeOrDefault($receiver_3, 10));
    var tmp$_1;
    tmp$_1 = $receiver_3.iterator();
    while (tmp$_1.hasNext()) {
      var item_0 = tmp$_1.next();
      destination_0.add_11rb$(toJs_18(item_0, i18nTranslator));
    }
    $receiver_1.datasets = copyToArray(destination_0);
    $receiver_0.data = $receiver_1;
    if ($receiver.options != null)
      $receiver_0.options = toJs_17($receiver.options, i18nTranslator);
    if ($receiver.plugins != null) {
      $receiver_0.plugins = copyToArray($receiver.plugins);
    }return Kotlin.isType(tmp$ = $receiver_0, Object) ? tmp$ : throwCCE();
  }
  function checkSingleValue($receiver) {
    var tmp$;
    if ($receiver.length === 1) {
      tmp$ = $receiver[0];
    } else {
      tmp$ = $receiver;
    }
    return tmp$;
  }
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  Object.defineProperty(package$kvision, 'KVManagerChart', {get: KVManagerChart_getInstance});
  Object.defineProperty(Chart_0, 'Companion', {get: Chart$Companion_getInstance});
  var package$chart = package$kvision.chart || (package$kvision.chart = {});
  package$chart.Chart = Chart_0;
  package$chart.chart_84p1gb$ = chart;
  package$chart.ChartCanvas = ChartCanvas;
  Object.defineProperty(ChartType, 'LINE', {get: ChartType$LINE_getInstance});
  Object.defineProperty(ChartType, 'BAR', {get: ChartType$BAR_getInstance});
  Object.defineProperty(ChartType, 'HORIZONTALBAR', {get: ChartType$HORIZONTALBAR_getInstance});
  Object.defineProperty(ChartType, 'RADAR', {get: ChartType$RADAR_getInstance});
  Object.defineProperty(ChartType, 'DOUGHNUT', {get: ChartType$DOUGHNUT_getInstance});
  Object.defineProperty(ChartType, 'PIE', {get: ChartType$PIE_getInstance});
  Object.defineProperty(ChartType, 'POLARAREA', {get: ChartType$POLARAREA_getInstance});
  Object.defineProperty(ChartType, 'BUBBLE', {get: ChartType$BUBBLE_getInstance});
  Object.defineProperty(ChartType, 'SCATTER', {get: ChartType$SCATTER_getInstance});
  package$chart.ChartType = ChartType;
  Object.defineProperty(Eeasing, 'LINEAR', {get: Eeasing$LINEAR_getInstance});
  Object.defineProperty(Eeasing, 'EASEINQUAD', {get: Eeasing$EASEINQUAD_getInstance});
  Object.defineProperty(Eeasing, 'EASEOUTQUAD', {get: Eeasing$EASEOUTQUAD_getInstance});
  Object.defineProperty(Eeasing, 'EASEINOUTQUAD', {get: Eeasing$EASEINOUTQUAD_getInstance});
  Object.defineProperty(Eeasing, 'EASEINCUBIC', {get: Eeasing$EASEINCUBIC_getInstance});
  Object.defineProperty(Eeasing, 'EASEOUTCUBIC', {get: Eeasing$EASEOUTCUBIC_getInstance});
  Object.defineProperty(Eeasing, 'EASEINOUTCUBIC', {get: Eeasing$EASEINOUTCUBIC_getInstance});
  Object.defineProperty(Eeasing, 'EASEINQUART', {get: Eeasing$EASEINQUART_getInstance});
  Object.defineProperty(Eeasing, 'EASEOUTQUART', {get: Eeasing$EASEOUTQUART_getInstance});
  Object.defineProperty(Eeasing, 'EASEINOUTQUART', {get: Eeasing$EASEINOUTQUART_getInstance});
  Object.defineProperty(Eeasing, 'EASEINQUINT', {get: Eeasing$EASEINQUINT_getInstance});
  Object.defineProperty(Eeasing, 'EASEOUTQUINT', {get: Eeasing$EASEOUTQUINT_getInstance});
  Object.defineProperty(Eeasing, 'EASEINOUTQUINT', {get: Eeasing$EASEINOUTQUINT_getInstance});
  Object.defineProperty(Eeasing, 'EASEINSINE', {get: Eeasing$EASEINSINE_getInstance});
  Object.defineProperty(Eeasing, 'EASEOUTSINE', {get: Eeasing$EASEOUTSINE_getInstance});
  Object.defineProperty(Eeasing, 'EASEINOUTSINE', {get: Eeasing$EASEINOUTSINE_getInstance});
  Object.defineProperty(Eeasing, 'EASEINEXPO', {get: Eeasing$EASEINEXPO_getInstance});
  Object.defineProperty(Eeasing, 'EASEOUTEXPO', {get: Eeasing$EASEOUTEXPO_getInstance});
  Object.defineProperty(Eeasing, 'EASEINOUTEXPO', {get: Eeasing$EASEINOUTEXPO_getInstance});
  Object.defineProperty(Eeasing, 'EASEINCIRC', {get: Eeasing$EASEINCIRC_getInstance});
  Object.defineProperty(Eeasing, 'EASEOUTCIRC', {get: Eeasing$EASEOUTCIRC_getInstance});
  Object.defineProperty(Eeasing, 'EASEINOUTCIRC', {get: Eeasing$EASEINOUTCIRC_getInstance});
  Object.defineProperty(Eeasing, 'EASEINELASTIC', {get: Eeasing$EASEINELASTIC_getInstance});
  Object.defineProperty(Eeasing, 'EASEOUTELASTIC', {get: Eeasing$EASEOUTELASTIC_getInstance});
  Object.defineProperty(Eeasing, 'EASEINOUTELASTIC', {get: Eeasing$EASEINOUTELASTIC_getInstance});
  Object.defineProperty(Eeasing, 'EASEINBACK', {get: Eeasing$EASEINBACK_getInstance});
  Object.defineProperty(Eeasing, 'EASEOUTBACK', {get: Eeasing$EASEOUTBACK_getInstance});
  Object.defineProperty(Eeasing, 'EASEINOUTBACK', {get: Eeasing$EASEINOUTBACK_getInstance});
  Object.defineProperty(Eeasing, 'EASEINBOUNCE', {get: Eeasing$EASEINBOUNCE_getInstance});
  Object.defineProperty(Eeasing, 'EASEOUTBOUNCE', {get: Eeasing$EASEOUTBOUNCE_getInstance});
  Object.defineProperty(Eeasing, 'EASEINOUTBOUNCE', {get: Eeasing$EASEINOUTBOUNCE_getInstance});
  package$chart.Eeasing = Eeasing;
  Object.defineProperty(InterpolationMode, 'DEFAULT', {get: InterpolationMode$DEFAULT_getInstance});
  Object.defineProperty(InterpolationMode, 'MONOTONE', {get: InterpolationMode$MONOTONE_getInstance});
  package$chart.InterpolationMode = InterpolationMode;
  $$importsForInline$$['kvision-jsLegacy'] = $module$kvision_jsLegacy;
  package$chart.toJs_pfee92$ = toJs;
  package$chart.AnimationOptions = AnimationOptions;
  package$chart.toJs_v11qg2$ = toJs_0;
  package$chart.LayoutPaddingObject = LayoutPaddingObject;
  package$chart.toJs_6d7gu4$ = toJs_1;
  package$chart.LayoutOptions = LayoutOptions;
  package$chart.toJs_vc4xam$ = toJs_2;
  package$chart.toJs_fkcpxh$ = toJs_3;
  package$chart.toJs_9mtj7z$ = toJs_4;
  package$chart.toJs_9wxg46$ = toJs_5;
  package$chart.toJs_edkcmy$ = toJs_6;
  package$chart.toJs_mmko9t$ = toJs_7;
  package$chart.toJs_jyqai6$ = toJs_8;
  package$chart.LineOptions = LineOptions;
  package$chart.toJs_x0mqs8$ = toJs_9;
  package$chart.toJs_pu3esw$ = toJs_10;
  package$chart.toJs_yhpreb$ = toJs_11;
  package$chart.ElementsOptions = ElementsOptions;
  package$chart.toJs_lt0y91$ = toJs_12;
  package$chart.toJs_f23kse$ = toJs_13;
  package$chart.toJs_p5v20i$ = toJs_14;
  package$chart.toJs_mh46db$ = toJs_15;
  package$chart.ChartScales = ChartScales;
  package$chart.toJs_70z95x$ = toJs_16;
  package$chart.ChartOptions = ChartOptions;
  package$chart.toJs_7y2iho$ = toJs_17;
  package$chart.DataSets = DataSets;
  package$chart.toJs_h0iwrl$ = toJs_18;
  package$chart.Configuration = Configuration;
  package$chart.toJs_k7uxos$ = toJs_19;
  kVManagerChartInit = KVManagerChart_getInstance().init_8be2vx$();
  return _;
}));

//# sourceMappingURL=kvision-kvision-chart-jsLegacy.js.map
